<template>
    <div>
        <div class="full">
            <div class="mainheader">
                <div class="half">
                    {{ $tc('pages.employeeData.contract') }}
                </div>

            </div>

        </div>
        <div class="full split-bottom" v-if="Object.values(employmentModelMap).length > 0 && !employee.isDummy">
            <div class="header">
                <div class="label">{{ $t('pages.employeeContract.employmentModel') }}</div>
            </div>
            <div class="half left">
                <div class="fourth">
                    <div class="label m4-top">{{ $t('pages.employeeContract.model') }}</div>
                </div>
                <div class="threefourths" style="z-index: 10;">
                    <dropdownsearch id="wizard-employeeType" :state="filtersEmploymentModel" />
                </div>
            </div>
        </div>
        <div v-if="contract" class="full split-bottom">
            <div class="header">
                <div class="label">{{ $t('pages.employeeContract.activeContract') }}</div>

            </div>
            <div class="third left">
                <div class="full">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.jobName') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ contract.jobName }}</div>
                    </div>
                </div>

                <div class="full split-bottom-tight">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.category') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ employeeCategoryMap[contract.employeeCategory] }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="third left">
                        <div class="label">{{ $tc('pages.employeeContract.contractType') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ contractTypeMap[contract.contractType] }}</div>
                    </div>
                </div>
                <div class="full" v-if="contract.partTimeType != null">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.partTimeType') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ partTimeTypeMap[contract.partTimeType] }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="third left">
                        <div class="label">
                            {{ $t(storeSettings.country == 1 ? 'pages.employeeContract.collectiveContract' : 'pages.employeeContract.contractModel')
                            }}
                        </div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">
                            {{ contract.collectiveContractId ? (allowedContractMap[contract.collectiveContractId] ? getCollectiveContractName(contract.collectiveContractId) : 'Unerlaubtes Vertragsmodell') : $t('roster.comp.noContractModel')
                            }}
                        </div>
                    </div>
                </div>
                <div class="full split-bottom">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.employmentType') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ employmentTypeMap[contract.employmentType] }}</div>
                    </div>
                </div>
                <div class="full " v-if="contract.accPeriodExclusion">
                    <div class="third left">
                        <div class="label">
                            {{ storeSettings.country == 2 ? $t('pages.employeeContract.accPeriodExclusionDE') : $t('pages.employeeContract.accPeriodExclusion')
                            }}
                        </div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ $t(contract.accPeriodExclusion ? 'global.ui.yes' : 'global.ui.no')
                            }}
                        </div>
                    </div>
                </div>
                <div class="full " v-if="!contract.accPeriodExclusion && contract.accPeriodPriority != null">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.accPeriodPriority') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">
                            {{ (itemsAccPeriodPriority.filter(i => i.value == contract.accPeriodPriority).length > 0) ? itemsAccPeriodPriority.filter(i => i.value == contract.accPeriodPriority)[0].label : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="full split-bottom">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.pregnancy') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ $t(contract.pregnant ? 'global.ui.yes' : 'global.ui.no') }}</div>


                    </div>
                </div>


            </div>
            <div class="third mid">
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.employmentGroup') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ contract.employmentGroup }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.contractFrom') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ $parent.employeeContractEntryDate(employee, false) }}</div>
                    </div>
                </div>
                <div class="full" v-if="hasContractChangeDate">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.contractChangeValidFrom') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ $helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY') }}</div>
                    </div>
                </div>
                <div v-if="contract.probationTo" class="full"
                     v-bind:class="{'split-bottom': !contract.deadlineTo && !contract.to}">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeContract.probationTo') }}</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">
                            {{ $helpers.getMomentFromStringTZ(contract.probationTo).add(-1, 'days').format('DD.MM.YYYY')
                            }}
                        </div>
                    </div>
                </div>
                <div v-if="contract.deadlineTo" class="full" v-bind:class="{'split-bottom': !contract.to}">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.deadlineTo') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">
                            {{ $helpers.getMomentFromStringTZ(contract.deadlineTo).add(-1, 'days').format('DD.MM.YYYY')
                            }}
                        </div>
                    </div>
                </div>
                <div v-if="contract.to" class="full split-bottom-tight">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.validUntil') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">
                            {{ $helpers.getMomentFromStringTZ(contract.to).add(-1, 'days').format('DD.MM.YYYY') }}
                        </div>
                    </div>
                </div>

                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.weekTimeRegular') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ minutesToHours(contract.weekTimeRegular) }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.weekWorkDaysRegular') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ contract.weekWorkDaysRegular }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.workDays') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ $helpers.formatWeekDayArray(contract.workDays) }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.additionalMonthWorkTime') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ minutesToHours(contract.additionalMonthWorkTime) }}</div>
                    </div>
                </div>

                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.weeklyOvertimeCutoff') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">
                            {{ minutesToHours(calculateOvertimeCutoffs(contract).weeklyOvertimeCutoff) }}
                        </div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.overtimeCutoff') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ minutesToHours(calculateOvertimeCutoffs(contract).overtimeCutoff)
                            }}
                        </div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.fullTimeCutoff') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ minutesToHours(contract.fullTimeCutoff) }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.dayFullTimeCutoff') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ minutesToHours(contract.dayFullTimeCutoff) }}</div>
                    </div>
                </div>
                <div class="full split-bottom">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.vacationTime') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ minutesToDays(contract.vacationTime) }}</div>
                    </div>
                </div>
                <div class="full split-bottom" v-if="contract.vacationEntitlementBase != null">
                    <div class="twothirds left">
                        <div class="label">{{ $t('pages.employeeContract.vacationEntitlementBase') }}</div>
                    </div>
                    <div class="third right">
                        <div class="label data">{{ contract.vacationEntitlementBase }}</div>
                    </div>
                </div>
            </div>
            <div class="third right">
                <div v-if="contractFileUploaded" class="full">
                    <div class="full">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.documentPresent') }}</div>
                        </div>
                        <div class="half">
                            <div class="button small" v-if="contractFile.accessToken" @click="openContractFile()">
                                <div class="label">
                                    {{ $t('pages.employeeContract.openContractDocument') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="full split-bottom-tight">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.contractUploaded') }}</div>
                        </div>
                        <div class="half">
                            <div class="label data">
                                {{ $helpers.extractDateStringTZ(contractFile.creationDate, 'DD.MM.YYYY | HH:mm') }}
                            </div>
                        </div>
                    </div>

                </div>
                <div v-else class="full">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeContract.noDocumentPresent') }}</div>
                    </div>
                </div>
                <div v-if="!contract.approved" class="full split-bottom">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeContract.contractNotApproved') }}</div>
                    </div>
                </div>
                <div v-else class="full split-bottom">
                    <div class="half left">
                        <div class="label">{{ $t('pages.employeeContract.approvedAt') }}</div>
                    </div>
                    <div class="half">
                        <div class="label data">
                            {{ $helpers.extractDateStringTZ(contract.approvalDate, 'DD.MM.YYYY | HH:mm') }}
                        </div>
                    </div>
                </div>

            </div>

            <div class="full">
                <div class="third left">
                    <div class="full">
                        <div class="header">
                            <div class="label">{{ $t('pages.employeeContract.payment') }}</div>
                        </div>
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.paymentType') }}</div>
                        </div>
                        <div class="twothirds right">
                            <div class="label data">{{ paymentTypeMap[contract.paymentType] }}</div>
                        </div>
                    </div>
                    <div class="full" v-if="contract.paymentType == 2">
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.wageType') }}</div>
                        </div>
                        <div class="twothirds right">
                            <div class="label data">{{ wageTypeMap[contract.wageType] }}</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.payment') }}</div>
                        </div>
                        <div v-if="!anonMode" class="twothirds right">
                            <div class="label data">{{ contract.payment / 100 }}</div>
                        </div>
                        <details v-else class="twothirds right">
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label data">{{ contract.payment / 100 }}</div>
                        </details>
                    </div>

                    <div class="full">
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.extraPayment') }}</div>
                        </div>
                        <div v-if="!anonMode" class="twothirds right">
                            <div class="label data">{{ contract.extraPayment / 100 }}</div>
                        </div>
                        <details v-else class="twothirds right">
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label data">{{ contract.extraPayment / 100 }}</div>
                        </details>
                    </div>

                    <div class="full">
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.totalPayment') }}</div>
                        </div>
                        <div v-if="!anonMode" class="twothirds right">
                            <div class="label data">{{ (contract.payment + contract.extraPayment) / 100 }}</div>
                        </div>
                        <details v-else class="twothirds right">
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label data">{{ (contract.payment + contract.extraPayment) / 100 }}</div>
                        </details>
                    </div>

                    <div class="full">
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.funding') }}</div>
                        </div>
                        <div v-if="!anonMode" class="twothirds right">
                            <div class="label data">{{ contract.assistancePayment / 100 }}</div>
                        </div>
                        <details v-else class="twothirds right">
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label data">{{ contract.assistancePayment / 100 }}</div>
                        </details>
                    </div>
                </div>
                <div class="third mid">
                    <div class="full" v-if="contract.holidayTypes.length > 0">
                        <div class="header">
                            <div class="label">{{ $t('pages.employeeContract.holidayBonus') }}</div>
                        </div>
                    </div>
                    <div class="full" v-if="contract.holidayTypes.length > 0">
                        <div class="half left">
                            <div class="label">{{ $t('workBalance.bonus.holidayType') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ $helpers.formatHolidayArray(contract.holidayTypes) }}</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="header">
                            <div class="label">{{ $t('pages.employeeContract.overTimeBonus') }}</div>
                        </div>
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.bonusHour') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ contract.overtimeBonusHour / 100 }}</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.bonusShift') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ contract.overtimeBonusShift / 100 }}</div>
                        </div>
                    </div>

                    
                </div>
                <div class="third right" v-if="contract.calculateNightWork">
                    
                    <div class="full">
                        <div class="header">
                            <div class="label">{{ $t('pages.employeeContract.nightWork') }}</div>
                        </div>
                    </div>
                    <div class="full" v-show="false">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.dayNight') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ nightWorkerTypeMap[contract.nightWorkerType] }}</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.nightWorkFrom') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ contract.nightWorkFrom }}</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.nightWorkTo') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ contract.nightWorkTo }}</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.nightWorkMode') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ nightWorkModeMap[contract.nightWorkMode] }}</div>
                        </div>
                    </div>
                    <div class="full"
                         v-if="contract.nightWorkMode == 1 || contract.nightWorkMode == 4 || contract.nightWorkMode == 5">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.nightWorkCutoff') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ (contract.nightWorkCutoff).toFixed(2) }}%</div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.minNightWorkTime') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ (contract.minNightWorkTime / 60.0).toFixed(2) }}h</div>

                        </div>
                    </div>
                    <div class="full"
                         v-if="contract.nightWorkMode == 1 || contract.nightWorkMode == 3 || contract.nightWorkMode == 5">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.bonusHour') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ contract.nightWorkBonusHour / 100 }}</div>
                        </div>
                    </div>
                    <div class="full"
                         v-if="contract.nightWorkMode == 1 || contract.nightWorkMode == 2 || contract.nightWorkMode == 4">
                        <div class="half left">
                            <div class="label">{{ $t('pages.employeeContract.bonusShift') }}</div>
                        </div>
                        <div class="half right">
                            <div class="label data">{{ contract.nightWorkBonusShift / 100 }}</div>
                        </div>
                    </div>


                </div>
                
            </div>
            <div class="full" v-if="contract.comment || contract.exitReason">
                <div class="third left">
                    <div class="full">
                        <div class="header">
                            <div class="label">{{ $t('global.general.additionalInfo') }}</div>
                        </div>
                    </div>
                    <div class="full" v-if="contract.comment">
                        <div class="third left">
                            <div class="label">{{ $t('global.general.comment') }}</div>
                        </div>
                        <div class="twothirds right">
                            <div class="label data">{{ contract.comment }}</div>
                        </div>
                    </div>
                    <div class="full" v-if="contract.exitReason">
                        <div class="third left">
                            <div class="label">{{ $t('pages.employeeContract.exitReason') }}</div>
                        </div>
                        <div class="twothirds right">
                            <div class="label data">
                                {{ exitReasonMap[contract.exitReason] ? exitReasonMap[contract.exitReason] : contract.exitReason
                                }}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div v-else class="full split-bottom">
            <div class="twothirds left">
                <div v-if="!futureContracts || futureContracts.length == 0" class="full">
                    <div class="full">
                        <div class="label">{{ $t('pages.employeeContract.noActiveContractPresent') }}</div>
                    </div>
                </div>
                <div v-else class="full">
                    <div class="header">
                        <div class="label">{{ $t('pages.employeeContract.createContract') }}</div>
                    </div>
                    <div class="cd-input">
                        <div class="label">{{ 'Der Arbeitsvertrag beginnt am ' + formattedDate(upcomingContract.from)
                            }}
                        </div>
                        <buttonc type="button icon-overlay square" :icon="'fas fa-envelope-open'"
                                 v-tooltip="$t('global.general.details')" @click="openDetails(upcomingContract)"/>
                    </div>
                </div>
                <div class="full">
                </div>
            </div>
        </div>

        <div v-if="futureContracts !== undefined && futureContracts.length > 0" class="full">
            <div class="header">
                <div class="label">{{ $t('pages.employeeContract.futureContracts') }}</div>
            </div>
            <datatablesimple :state="futureContractsState" />
        </div>

        <div v-if="pastContracts !== undefined && pastContracts.length > 0" class="full">
            <div class="header">
                <div class="label">{{ $t('pages.employeeContract.pastContracts') }}</div>
            </div>
            <datatablesimple :state="pastContractsState" />
        </div>

        <div class="discarder" v-if="modalCreatecontract || modalContractdetails || modalEndcontract ||
            modalEditorend || modalUploaderror"
             @click="modalCreatecontract = false; modalContractdetails = false; modalEndcontract = false;
             modalEditorend = false; modalUploaderror = false;">
        </div>

        <div class="md-card wide" v-if="modalCreatecontract">
            <h6 class="md-card-header" style="text-align: left">
                {{
                    ((contractToEdit && contractToEdit.approved && editingCurrentContract) || !editing) ?
                    this.$t('pages.employeeContract.createNewWorkContract') : this.$t('global.ui.editX', [this.$t('pages.employeeContract.contract')])
                }}
                <i class="fas fa-times" style="float: right"
                   @click="closeCreateContract"></i>
            </h6>
            <div class="md-card-body">
                <div style="height: 12px; width: 100%;"></div>
                <div v-show="wizardPage === 1">
                    <labelc type="header" class="wide-label" :text="$tc('pages.employeeContract.template', 2)"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <labelc type="header" class="label" :text="$tc('pages.employeeContract.contractTemplate', 1)" />
                        <div @click="toggleInputPopup('contractTemplate', false)" class="dropdown">
                            <dropdownsearch id="wizard-contractTemplate" class="filters"
                                            :state="filtersContractTemplate" />
                        </div>
                    </div>
                    <div v-if="newContract.templateCode !== 0" class="md-card-select">
                        <labelc type="header" class="label"
                                :text="$t('pages.employeeContract.errors.templateMissing')" />
                        <div @click="popupContracttemplateName = false; popupContracttemplateNameDuplicate = false"
                             class="cd-input">
                            <input @focus="toggleInputPopup('templateName', false)" type="text"
                                   v-model="newContract.templateName" />
                        </div>
                        <div v-if="popupContracttemplateName" class="error-label">{{
                                $t('pages.employeeContract.errors.contractFromMissing')
                            }}
                        </div>
                        <div v-if="popupContracttemplateNameDuplicate" class="error-label">{{
                                $t('pages.employeeContract.errors.templateExists')
                            }}
                        </div>
                    </div>
                    <div v-show="newContract.templateCode !== 0 && newContract.templateCode !== -1"
                         class="md-card-select noborder">
                        <labelc type="header" class="label" :text="$t('pages.employeeContract.updateTemplate')" />
                        <i class="fas fa-check-circle checkbox coredata"
                           @click="newContract.templateUpdate = !newContract.templateUpdate;"
                           v-bind:class="{'true' : newContract.templateUpdate, 'false' : !newContract.templateUpdate}"></i>
                        <div class="button next red" style="margin-left:25px" @click="deleteContractTemplate()">
                            <div class="label">{{ $t('pages.employeeContract.deleteTemplate') }}</div>
                        </div>
                    </div>

                    <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.baseData')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <div class="full">
                            <div class="half">
                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.jobName')" />
                                    <input @focus="popupJobName = false" type="text" v-model="newContract.jobName" />
                                    <div v-if="popupJobName" class="error-label">{{
                                            $t('pages.employeeContract.errors.jobNameMissing')
                                        }}
                                    </div>
                                </div>
                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.employmentType')" />
                                    <div @click="popupEmploymentType = false" class="dropdown">
                                        <dropdownsearch class="filters" :state="filtersEmploymentType" />
                                    </div>
                                    <div v-if="popupEmploymentType" class="error-label">{{
                                            $t('pages.employeeContract.errors.employmentTypeMissing')
                                        }}
                                    </div>
                                </div>
                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.category')" />
                                    <div @click="popupEmployeeCategory = false" class="dropdown">
                                        <dropdownsearch class="filters" :state="filtersEmployeeCategory" />
                                    </div>
                                    <div v-if="popupEmployeeCategory" class="error-label">{{
                                            $t('pages.employeeContract.errors.employeeCategoryMissing')
                                        }}
                                    </div>
                                </div>
                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$tc('pages.employeeContract.contractType')" />
                                    <div @click="popupContractType = false" class="dropdown">
                                        <dropdownsearch class="filters" :state="filtersContractType" />
                                    </div>
                                    <div v-if="popupContractType" class="error-label">{{
                                            $t('pages.employeeContract.errors.contractTypeMissing')
                                        }}
                                    </div>
                                </div>
                                </div>
                                <div class="half right">
                                    <div class="cd-input">
                                        <labelc type="header" class="label" :text="$t('pages.employeeContract.employmentGroup')" />
                                        <input v-if="newContract.mlWageGroup == null"
                                            type="text" v-model="newContract.employmentGroup" />
                                        <div v-else style="font-size: 13px; padding: 4px 4px; width: 320px">{{ newContract.employmentGroup }}
                                        </div>
                                    </div>
                                <div class="cd-input">
                                    <labelc v-if="newContract.contractType !== 1 && storeSettings.country === 1"
                                            type="header" class="label" :text="$t('pages.employeeContract.partTimeType')" />
                                    <div v-if="newContract.contractType !== 1 && storeSettings.country === 1" class="dropdown">
                                        <dropdownsearch id="wizard-partTimeType" class="filters" :state="filtersPartTimeType" />
                                    </div>
                                </div>

                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.pregnancy')" />
                                    <div class="cb-container">
                                        <i class="fas fa-check-circle checkbox coredata"
                                        @click="(newContract.pregnant)? newContract.pregnant = false : newContract.pregnant = true;"
                                        v-bind:class="{'true' : newContract.pregnant, 'false' : !newContract.pregnant}"></i>
                                    </div>
                                </div>

                                <div class="cd-input">
                                    <labelc type="header" class="label"
                                            :text="storeSettings.country === 2 ? $t('pages.employeeContract.accPeriodExclusionDE') :
                                    $t('pages.employeeContract.accPeriodExclusion')" />
                                    <div class="cb-container">
                                        <i class="fas fa-check-circle checkbox coredata" :disabled="!canEditStoreBaseData"
                                        @click="toggleAccPeriod(newContract)"
                                        v-bind:class="{'true' : newContract.accPeriodExclusion, 'false' : !newContract.accPeriodExclusion}"></i>
                                    </div>
                                </div>

                                <div class="cd-input">
                                    <labelc v-if="canEditStoreBaseData && !newContract.accPeriodExclusion"
                                            type="header" class="label"
                                            :text="$t('pages.employeeContract.accPeriodPriority')" />
                                    <div v-if="canEditStoreBaseData && !newContract.accPeriodExclusion"
                                        @click="toggleInputPopup('accPeriodPriority', false)" class="dropdown">
                                        <dropdownsearch id="wizard-accPeriodPriority" class="filters"
                                                        :state="filtersAccPeriodPriority" />
                                        </div>
                                    </div>
                                </div>

                        </div>
                    </div>

                    <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.validityAndProbation')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <div class="half">
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('pages.employeeContract.validFrom')" />
                            <input @focus="popupFrom = false" type="date" v-model="fromDate" />
                            <div v-if="popupFrom" class="error-label">{{
                                    $t('pages.employeeContract.errors.contractFromMissing')
                                }}
                            </div>
                        </div>

                        <div class="cd-input">
                            <labelc v-if="newContract.employmentType !== 2 && newContract.to != null" type="header"
                                    class="label" :text="$t('pages.employeeContract.noContractEnd')" />
                            <div v-if="newContract.employmentType !== 2 && newContract.to != null" class="cb-container">
                                <i class="fas fa-check-circle checkbox coredata" @click="noContractTo = !noContractTo;"
                                   v-bind:class="{'true' : noContractTo, 'false' : !noContractTo}"></i>
                            </div>
                        </div>

                        <div class="cd-input">
                            <labelc v-if="newContract.employmentType === 2 || newContract.to != null" type="header"
                                    class="label" :text="$t('pages.employeeContract.contractEnd')" />
                            <input v-if="newContract.employmentType === 2 || newContract.to != null"
                                   @focus="popupTo = false" type="date" v-model="toDate" />
                            <div v-if="popupTo" class="error-label">{{
                                    $t('pages.employeeContract.errors.contractToMissing')
                                }}
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('pages.employeeContract.extraDeadline')" />
                            <div class="cb-container">
                                <i class="fas fa-check-circle checkbox coredata"
                                   @click="deadlineEnabled = !deadlineEnabled"
                                   v-bind:class="{'true' : deadlineEnabled, 'false' : !deadlineEnabled}"></i>
                            </div>
                        </div>

                        <div class="cd-input">
                            <labelc v-if="deadlineEnabled" type="header" class="label"
                                    :text="$t('pages.employeeContract.deadlineTo')" />
                            <div v-if="deadlineEnabled" class="cd-input">
                                <input @focus="popupDeadlineTo = false" type="date" v-model="deadlineToDate" />
                            </div>
                            <div v-if="popupDeadlineTo" class="error-label">{{
                                    $t('pages.employeeContract.errors.deadlineToMissing')
                                }}
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('pages.employeeContract.probation')" />
                            <div class="cb-container">
                                <i class="fas fa-check-circle checkbox coredata"
                                   @click="probationEnabled = !probationEnabled"
                                   v-bind:class="{'true' : probationEnabled, 'false' : !probationEnabled}"></i>
                            </div>
                        </div>

                        <div class="cd-input">
                            <labelc v-if="probationEnabled" type="header" class="label"
                                    :text="$t('pages.employeeContract.probationTo')" />
                            <div v-if="probationEnabled" class="cd-input">
                                <input @focus="popupProbationTo = false"
                                       type="date" v-model="probationToDate" />
                            </div>
                            <div v-if="popupProbationTo" class="error-label">{{
                                    $t('pages.employeeContract.errors.probationToMissing')
                                }}
                            </div>
                        </div>
                    </div>
                        <div class="half right">
                        <div class="cd-input">
                            <labelc type="header" class="label"
                                    :text="$t('pages.employeeContract.allowPartialShifts')" />
                            <div class="cb-container">
                                <i class="fas fa-check-circle checkbox coredata"
                                   @click="(newContract.allowPartialShifts)? newContract.allowPartialShifts = false : newContract.allowPartialShifts = true;"
                                   v-bind:class="{'true' : newContract.allowPartialShifts, 'false' : !newContract.allowPartialShifts}"></i>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t(storeSettings.country === 1 ?
                         'pages.employeeContract.collectiveContract' : 'pages.employeeContract.contractModel')" />
                            <div class="cb-container">
                                <i v-if="!ccMandatory" class="fas fa-check-circle checkbox coredata"
                                   @click="ccEnabled = !ccEnabled;"
                                   v-bind:class="{'true' : ccEnabled, 'false' : !ccEnabled}"></i>
                                <i v-else class="fas fa-check-circle checkbox coredata true"></i>
                            </div>
                        </div>

                        <div class="cd-input">
                            <labelc v-if="ccEnabled" type="header" class="label"
                                    :text="$t('pages.employeeContract.selectContract') + ':'" />
                            <div v-if="ccEnabled" @click="popupCollectiveContract = false" class="dropdown">
                                <dropdownsearch class="filters" :state="filtersCollectiveContract" />
                            </div>
                            <div v-if="popupCollectiveContract" class="error-label">{{
                                    $t('pages.employeeContract.errors.collectiveContractMissing')
                                }}
                            </div>
                        </div>
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.workDays')" />
                                <div class="dropdown">
                                    <div class="toggle-list" type="number">
                                        <div class="toggle" v-for="(toggle, indexT) in toggleEntries"
                                            :disabled="!canEditStoreBaseData"
                                            v-on:click="ToggleListItem(toggle)"
                                            v-bind:class="{selected: toggle.selected}" :key="indexT">
                                            {{ toggle.label }}
                                        </div>
                                        <div class="toggle"
                                            :disabled="!canEditStoreBaseData"
                                            v-on:click="ToggleAllListItems()"
                                            v-bind:class="{selected: toggleAll}">
                                            Alle
                                        </div>
                                    </div>
                                </div>
                                <div v-if="popupWorkDays" class="error-label">{{
                                        $t('pages.employeeContract.errors.workDaysInvalid')
                                    }}
                                </div>
                            </div>
                        </div>



                    </div>
                    <div class="md-card-select noborder" v-bind:class="{muted: newContract.collectiveContractId }">
                        <div class="fourth">
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.weekTimeRegular')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model.number="weekTimeRegularHours" />
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.daysPerWeek')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model="newContract.weekWorkDaysRegular" />
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.additionalMonthWorkTime')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model.number="additionalMonthWorkTimeHours" />
                                </div>
                            </div>
                        </div>
                        <div class="fourth">
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.fullTimeCutoff')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model="fullTimeCutoff" />
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.dayFullTimeCutoff')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model="dayFullTimeCutoff" />
                                </div>
                            </div>

                        </div>
                        <div class="fourth">
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.weeklyOvertimeCutoff')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model="weeklyOvertimeCutoff" />
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.overtimeCutoff')" />
                                <div class="cd-input roinput">
                                    <input :disabled="newContract.collectiveContractId"
                                        v-model.number="overtimeCutoff" />
                                </div>
                            </div>
                        </div>
                        <div class="fourth">
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.weekTimeMaxHours')" />
                                <div class="cd-input roinput">
                                    <input disabled type="text" v-model="weekTimeMaxHours" />
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.monthWorkTime')" />
                                <div class="cd-input roinput">
                                    <input disabled type="text" v-model="monthTimeRegularHours" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!editing && storeSettings && !storeSettings.simpleMode">
                        <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.planning')"
                                :styleText="titleStyle" :style=headerLabelStyle />
                        <div class="md-card-select noborder">
                            <div class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.planningEmployeeType')" />
                                <div @click="popupEmployeeType = false" class="dropdown">
                                    <dropdownsearch class="filters" :state="filtersEmployeeType" />
                                </div>
                                <div v-if="popupEmployeeType" class="error-label">{{
                                        $t('pages.employeeContract.errors.employeeTypeMissing')
                                    }}
                                </div>
                            </div>
                            <div v-if="newContract.employeeType != undefined" class="full muted">
                                <div v-if="collectiveContractEmployeeTypeDiffWarning()">
                                    <div class="full-split-flat">
                                    </div>
                                    <div class="full split-bottom-tight danger">
                                        <div class="third left">
                                            <div class="label error">{{ $t('global.ui.warning') }}</div>
                                        </div>
                                        <div class="twothirds">
                                            <div class="label">
                                                <div class="label error">
                                                    {{ $t('pages.employeeContract.deviationWarning') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="half left">
                                        <div class="half left">
                                            <div class="label">{{ $t('pages.employeeContract.weekTimeRegular') }}
                                            </div>
                                        </div>
                                        <div class="half cd-input roinput">
                                            <input disabled type="text" v-model="typeWeekTimeRegularHours" />
                                        </div>
                                    </div>
                                    <div class="half">
                                        <div class="half left">
                                            <div class="label">{{ $t('pages.employeeContract.daysPerWeek') }}</div>
                                        </div>
                                        <div class="half cd-input roinput">
                                            <input disabled type="text"
                                                   v-model="newContract.employeeType.weekWorkDaysRegular" />
                                        </div>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="half left">
                                        <div class="half left">
                                            <div class="label">{{ $t('pages.employeeContract.weekTimeMaxHours') }}
                                            </div>
                                        </div>
                                        <div class="half cd-input roinput">
                                            <input disabled type="text" v-model="typeWeekTimeMaxHours" />
                                        </div>
                                    </div>
                                    <div class="half">
                                        <div class="half left">
                                            <div class="label">{{ $t('pages.employeeContract.monthWorkTime') }}
                                            </div>
                                        </div>
                                        <div class="half cd-input roinput">
                                            <input disabled type="text" v-model="typeMonthTimeRegularHours" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <labelc type="header" class="wide-label"
                            :text="$t('pages.employeeContract.vacationEntitlement')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('pages.employeeContract.vacationTime')" />
                            <input @focus="popupVacationTime = false" type="text" v-model="vacationTimeDays" />
                        </div>
                        <div v-if="popupVacationTime" class="error-label">{{
                                $t('pages.employeeContract.errors.vacationTimeMissing')
                            }}
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('pages.employeeContract.vacationEntitlementBase')" />
                            <input type="numeric" v-model="newContract.vacationEntitlementBase" />
                        </div>
                    </div>

                    <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.wageSalary')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <div class="half">
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.mlWageGroup')" />
                                <div @click="popupMlWageGroup = false" class="dropdown">
                                    <dropdownsearch class="filters" :state="filtersMlWageGroup" />
                                </div>
                                <div v-if="popupMlWageGroup" class="error-label">{{
                                        $t('pages.employeeContract.errors.mlWageGroupMissing')
                                    }}
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.paymentType')" />
                                <div @click="popupPaymentType = false" class="dropdown">
                                    <dropdownsearch class="filters" :state="filtersPaymentType" />
                                </div>
                                <div v-if="popupPaymentType" class="error-label">{{
                                        $t('pages.employeeContract.errors.paymentMissing')
                                    }}
                                </div>
                            </div>
                            <div v-if="newContract.paymentType === 2" class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.wageType')" />
                                <div @click="popupWageType = false" class="dropdown">
                                    <dropdownsearch class="filters" :state="filtersWageType" />
                                </div>
                                <div v-if="popupWageType" class="error-label">{{
                                        $t('pages.employeeContract.errors.wageTypeMissing')
                                    }}
                                </div>
                            </div>
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.totalPayment')" />
                                <div v-if="!anonMode" class="cd-input">

                                    <div style="font-size: 12px; font-weight: bold; padding: 4px 4px; width: 320px">{{ contractPopupTotalPayment }}
                                    </div>

                                </div>
                                <details v-else class="cd-input">
                                    <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                                    <div style="font-size: 12px; font-weight: bold; padding: 4px 4px; width: 320px">{{ contractPopupTotalPayment }}</div>
                                </details>
                            </div>
                        </div>
                        <div class="half right">
                            <div v-if="newContract.paymentType" class="md-card-select noborder">
                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.payment')" />
                                    <div v-if="!anonMode" class="cd-input">
                                        <input v-if="!newContract.mlPaymentFound"
                                            @focus="toggleInputPopup('payment', false)" id="wizard-payment"
                                            type="text"
                                            v-on:change="UpdateNightWorkBonus"
                                            v-model="newContract.payment" />
                                        <div v-else style="font-size: 13px; padding: 4px 4px; width: 320px">{{ newContract.payment.toFixed(2) }}
                                        </div>
                                    </div>
                                    <details v-else class="cd-input">
                                        <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                                        <input v-if="!newContract.mlPaymentFound"
                                               @focus="toggleInputPopup('payment', false)" id="wizard-payment"
                                               type="text"
                                               v-on:change="UpdateNightWorkBonus"
                                               v-model="newContract.payment" />
                                        <div v-else style="font-size: 13px; padding: 4px 4px; width: 320px">{{ newContract.payment.toFixed(2) }}
                                        </div>
                                    </details>
                                </div>
                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.extraPayment')" />
                                    <div v-if="!anonMode" class="cd-input">
                                        <input @focus="popupExtraPayment = false" v-on:change="UpdateNightWorkBonus" type="text"
                                            v-model="newContract.extraPayment" />
                                    </div>
                                    <details v-else class="cd-input">
                                        <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                                        <input @focus="popupExtraPayment = false" v-on:change="UpdateNightWorkBonus" type="text"
                                               v-model="newContract.extraPayment" />
                                    </details>
                                    <div v-if="popupExtraPayment" class="error-label">{{
                                            $t('pages.employeeContract.errors.extraPaymentMissing')
                                        }}
                                    </div>
                                </div>

                                <div class="cd-input">
                                    <labelc type="header" class="label" :text="$t('pages.employeeContract.funding')" />
                                    <div v-if="!anonMode" class="cd-input">
                                        <input id="wizard-assistancePayment" type="text"
                                            v-model="newContract.assistancePayment" />
                                    </div>
                                    <details v-else class="cd-input">
                                        <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                                        <input id="wizard-assistancePayment" type="text"
                                               v-model="newContract.assistancePayment" />
                                    </details>
                                </div>
                            </div>
                        </div>
                    </div>

                    <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.overtimeAndHolidayBonus')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <div class="full">
                            <div class="half left">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.holidayBonus')" />
                                <dropdownsearch class="filters" :state="filtersHolidayTypes" />
                            </div>
                            
                        </div>
                        <div class="half">
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.overtimeBonusHour')" />
                                <div class="cd-input">
                                    <input id="wizard-overtimeBonusHour" type="text"
                                        v-model="newContract.overtimeBonusHour" />
                                </div>
                            </div>
                        </div>
                        <div class="half right">
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.overtimeBonusFlat')" />
                                <div class="cd-input">
                                    <input id="wizard-overtimeBonusShift" type="text"
                                        v-model="newContract.overtimeBonusShift" />
                                </div>
                            </div>
                        </div>
                        

                    </div>

                    <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.nightWork')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <div class="half">
                            <div class="cd-input" style="margin-bottom: 4px;">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.calculateNightWork')" />
                                <div class="cb-container">
                                    <i class="fas fa-check-circle checkbox coredata"
                                    @click="(newContract.calculateNightWork && !storeSettings.nightWorkRequired)? newContract.calculateNightWork = false : newContract.calculateNightWork = true;"
                                    v-bind:class="{'true' : newContract.calculateNightWork, 'false' : !newContract.calculateNightWork}"></i>
                                </div>
                            </div>
                            <div v-if="newContract.calculateNightWork" class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.nightWorkFrom')" />
                                <div class="cd-input">
                                    <input @focus="popupNightWorkFrom = false" type="time"
                                        v-model="newContract.nightWorkFrom" />
                                </div>
                                <div v-if="popupNightWorkFrom" class="error-label">{{
                                        $t('pages.employeeContract.errors.nightWorkFromInvalid')
                                    }}
                                </div>
                            </div>
                            <div v-if="newContract.calculateNightWork" class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.nightWorkTo')" />
                                <div class="cd-input">
                                    <input @focus="popupNightWorkTo = false" type="time"
                                        v-model="newContract.nightWorkTo" />
                                </div>
                                <div v-if="popupNightWorkTo" class="error-label">{{
                                        $t('pages.employeeContract.errors.nightWorkToInvalid')
                                    }}
                                </div>
                            </div>
                            <div v-if="newContract.calculateNightWork" class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.minNightWorkTime')" />
                                <div class="slide-container">
                                    <slider style="top: 5px; left: -10px;" class="slider"
                                            :state="{inputControl: true, hideMin: true, hideMax: true, min: 0, max: 12*60,
                                             value: newContract.minNightWorkTime, step: 15, DisplayLabel: (x) => {return (x/60.0).toFixed(2)+'h'},
                                             sliderInput: (x) => {return (x * 60.0)}, labelToInt: (x) => {return x.slice(0, -1)}}"
                                            @callback="(val, obj) => {newContract.minNightWorkTime = val}"></slider>
                                </div>
                            </div>
                        </div>
                        <div class="half right">
                            <div v-if="newContract.calculateNightWork" class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.nightWorkMode')" />
                                <div @click="popupNightWorkMode = false" class="dropdown">
                                    <dropdownsearch class="filters" :state="filtersNightWorkMode" />
                                </div>
                                <div v-if="popupNightWorkMode" class="error-label">{{
                                        $t('pages.employeeContract.errors.nightWorkModeMissing')
                                    }}
                                </div>
                            </div>
                            <div v-if="newContract.calculateNightWork && (newContract.nightWorkMode === 1 ||
                            newContract.nightWorkMode === 4 || newContract.nightWorkMode === 5)" class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContract.nightWorkCutoff')" />
                                <div class="dropdown">
                                    <div class="label data">{{ (newContract.nightWorkCutoff).toFixed(2) }}%</div>
                                </div>
                            </div>

                            
                            <div v-if="newContract.calculateNightWork && (newContract.nightWorkMode === 1 ||
                            newContract.nightWorkMode === 3 || newContract.nightWorkMode === 5) " class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.bonusHour')" />
                                <div class="cd-input" v-if="!newContract.useNightWorkBonusHourPercentage">
                                    <input id="wizard-nightWorkBonusHour" type="text" v-model="newContract.nightWorkBonusHour" />
                                </div>
                                <div v-else style="font-size: 13px; padding: 4px 4px; width: 320px">{{ newContract.nightWorkBonusHour }}
                                </div>
                            </div>
                            
                            <div v-if="newContract.calculateNightWork && (newContract.nightWorkMode === 1 ||
                            newContract.nightWorkMode === 2 || newContract.nightWorkMode === 4)" class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.bonusShift')" />
                                <div class="cd-input">
                                    <input id="wizard-nightWorkBonusShift" type="text"
                                        v-model="newContract.nightWorkBonusShift" />
                                </div>
                            </div>

                            <div v-if="newContract.calculateNightWork && (newContract.nightWorkMode === 1 ||
                            newContract.nightWorkMode === 3 || newContract.nightWorkMode === 5)" class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContext.hourlyPayBonusPercentage')" />
                                <div class="cb-container">
                                    <i class="fas fa-check-circle checkbox coredata"
                                    v-on:click="ToggleContractField('useNightWorkBonusHourPercentage')"
                                    v-bind:class="{'true' : newContract.useNightWorkBonusHourPercentage, 'false' : !newContract.useNightWorkBonusHourPercentage}"></i>
                                </div>
                            </div>
                            
                            <div v-if="newContract.calculateNightWork && newContract.useNightWorkBonusHourPercentage" class="cd-input">
                                <labelc type="header" class="label"
                                        :text="$t('pages.employeeContext.percentageRate')" />
                                <div class="slide-container">
                                    <slider style="top: 5px; left: -10px;" class="slider"
                                            :state="{inputControl: true, hideMin: true, hideMax: true, min: 0, max: 100,
                                             value: newContract.nightWorkBonusPercentage, step: 1, DisplayLabel: (x) => {return x+'%'},
                                             sliderInput: (x) => {return x}, 
                                             labelToInt: (x) => {
                                                
                                                return x

                                             }}"
                                            @callback="(val, obj) => {
                                                SetNightBonusPercentage(val)

                                            }"></slider>
                                </div>
                            </div>
                        </div>
                    </div>

                    <labelc type="header" class="wide-label" :text="$t('global.general.additionalInfo')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select">
                        <div class="half">
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('global.general.comment')" />
                                <div class="cd-input">
                                    <input id="wizard-comment" type="text" v-model="newContract.comment" />
                                </div>
                            </div>
                        </div>
                        <div class="half right">
                            <div class="cd-input">
                                <labelc type="header" class="label" :text="$t('pages.employeeContract.exitReason')" />
                                <div class="dropdown">
                                    <dropdownsearch id="wizard-exitReason" class="filters"
                                                    :state="filtersExitReason" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasErrors > 0" class="error-label">{{
                            this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheck')
                        }} ({{ hasErrors }})
                    </div>
                </div>
                <div v-show="wizardPage == 2">
                    <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.validFromDialogTitle')"
                            :styleText="titleStyle" :style=headerLabelStyle />
                    <div class="md-card-select noborder">
                        <labelc type="header" class="label" :text="$t('pages.employeeContract.validFrom')" />
                        <div class="cd-input">
                            <input @focus="toggleInputPopup('from', false)" type="date"
                                   v-model="fromDate" />
                        </div>
                        <div v-if="popupFrom" class="error-label">{{
                                $t('pages.employeeContract.errors.contractFromMissing')
                            }}
                        </div>
                    </div>
                    <div v-if="hasErrors > 0" class="error-label">{{
                            this.$t('pages.employeeCoreData.errorCreatingEmployeeMandatoryCheck')
                        }} ({{hasErrors}})
                    </div>
                </div>
                <div v-show="wizardPage == 3" style="height: 200px;">
                    <div class="loading">
                        <i class="fas fa-spinner"></i>
                    </div>
                </div>
                <div class="right">
                    <buttonc type="rectangle green"
                             :label="$t(editing ? (!newContract.approved || newContract.approved && wizardPage == 3 ?
                                      'global.ui.saveChanges' : 'global.ui.next') : 'pages.employeeContract.createContract')"
                             @click="wizardNext()" style="width: auto; float: right" />
                    <buttonc type="rectangle" :label="$t('global.ui.cancel')" @click="closeCreateContract"
                             v-bind:class="{disabled: wizardPage == 3}" style="width: auto; float: right" />
                </div>
            </div>
        </div>


        <div class="md-card" v-if="modalContractdetails">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('pages.employeeContract.contractDetails') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalContractdetails = false"></i>
            </h6>
            <div v-if="detailContract" class="md-card-body">
                <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.contractChange')"
                        :styleText="titleStyle" style="width: 100%" />
                <div class="md-card-select">
                    <div v-if="parentContract(detailContract) != null">
                        <labelc type="header" class="auto-label" :text=" $t('pages.employeeContract.proceedsContractFrom') +
                         ' ' + $helpers.extractDateStringTZ(parentContract(detailContract).from, 'DD.MM.YYYY')" />
                        <buttonc type="button icon-overlay square" :icon="'fas fa-envelope-open'"
                                 v-tooltip="$t('pages.employeeContract.showContract')"
                                 @click="openDetails(parentContract(detailContract))" />
                    </div>
                    <div v-if="childContract(detailContract) != null">
                        <labelc type="header" class="auto-label" :text=" $t('pages.employeeContract.proceededByContractChangeAt') +
                         ' ' + $helpers.extractDateStringTZ(childContract(detailContract).from, 'DD.MM.YYYY')" />
                        <buttonc type="button icon-overlay square" :icon="'fas fa-envelope-open'"
                                 v-tooltip="$t('pages.employeeContract.showContract')"
                                 @click="openDetails(childContract(detailContract))" />
                    </div>
                </div>

                <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.contract')"
                        :styleText="titleStyle" style="width: 100%" />
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.jobName')" />
                        <div class="label">{{ detailContract.jobName }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label"
                                :text=" $t('pages.employeeContract.employmentGroup')" />
                        <div class="label">{{ detailContract.employmentGroup }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.category')" />
                        <div class="label">{{ employeeCategoryMap[detailContract.employeeCategory] }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $tc('pages.employeeContract.contractType')" />
                        <div class="label">{{ contractTypeMap[detailContract.contractType] }}</div>
                    </div>
                    <div class="cd-input" v-if="detailContract.partTimeType != null">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.partTimeType')" />
                        <div class="label">{{ partTimeTypeMap[detailContract.partTimeType] }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.employmentType')" />
                        <div class="label">{{ employmentTypeMap[detailContract.employmentType] }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.pregnancy')" />
                        <div class="label">{{ $t(detailContract.pregnant ? 'global.ui.yes' : 'global.ui.no') }}</div>
                    </div>
                </div>
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text="  storeSettings.country == 2 ?
                         $t('pages.employeeContract.accPeriodExclusionDE') : $t('pages.employeeContract.accPeriodExclusion')" />
                        <div class="label">
                            {{ $t(detailContract.accPeriodExclusion ? 'global.ui.yes' : 'global.ui.no') }}
                        </div>
                    </div>
                </div>
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.validFrom')" />
                        <div class="label">{{ $helpers.extractDateStringTZ(detailContract.from, 'DD.MM.YYYY') }}</div>
                    </div>
                    <div v-if="detailContract.probationTo" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.probationTo')" />
                        <div class="label data">
                            {{ $helpers.getMomentFromStringTZ(detailContract.probationTo).add(-1, 'days').format('DD.MM.YYYY')
                            }}
                        </div>
                    </div>
                    <div v-if="detailContract.deadlineTo" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.deadlineTo')" />
                        <div class="label">
                            {{ $helpers.getMomentFromStringTZ(detailContract.deadlineTo).add(-1, 'days').format('DD.MM.YYYY')
                            }}
                        </div>
                    </div>
                    <div v-if="detailContract.to" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.validUntil')" />
                        <div class="label">
                            {{ $helpers.getMomentFromStringTZ(detailContract.to).add(-1, 'days').format('DD.MM.YYYY') }}
                        </div>
                    </div>
                </div>
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.weekTimeRegular')" />
                        <div class="label">{{ minutesToHours(detailContract.weekTimeRegular) }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label"
                                :text=" $t('pages.employeeContract.additionalMonthWorkTime')" />
                        <div class="label">{{ minutesToHours(detailContract.additionalMonthWorkTime) }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.weekWorkDaysRegular')" />
                        <div class="label">{{ detailContract.weekWorkDaysRegular }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.workDays')" />
                        <div class="label">{{ $helpers.formatWeekDayArray(detailContract.workDays) }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label"
                                :text=" $t('pages.employeeContract.weeklyOvertimeCutoff')" />
                        <div class="label">
                            {{ minutesToHours(calculateOvertimeCutoffs(detailContract).weeklyOvertimeCutoff) }}
                        </div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.overtimeCutoff')" />
                        <div class="label">
                            {{ minutesToHours(calculateOvertimeCutoffs(detailContract).overtimeCutoff) }}
                        </div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.fullTimeCutoff')" />
                        <div class="label">{{ minutesToHours(detailContract.fullTimeCutoff) }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.dayFullTimeCutoff')" />
                        <div class="label">{{ minutesToHours(detailContract.dayFullTimeCutoff) }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.vacationTime')" />
                        <div class="label">{{ minutesToDays(detailContract.vacationTime) }}</div>
                    </div>
                    <div class="cd-input" v-if="detailContract.vacationEntitlementBase != null">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.vacationEntitlementBase')" />
                        <div class="label">{{ detailContract.vacationEntitlementBase }}</div>
                    </div>
                    
                </div>

                <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.payment')"
                        :styleText="titleStyle" style="width: 100%" />
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.paymentType')" />
                        <div class="label">{{ paymentTypeMap[detailContract.paymentType] }}</div>
                    </div>
                    <div v-if="detailContract.paymentType == 2" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.wageType')" />
                        <div class="label">{{ wageTypeMap[detailContract.wageType] }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.payment')" />
                        <div v-if="!anonMode" class="label">{{ detailContract.payment / 100 }}</div>
                        <details v-else>
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label">{{ detailContract.payment / 100 }}</div>
                        </details>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.extraPayment')" />
                        <div v-if="!anonMode" class="label">{{ detailContract.extraPayment / 100 }}</div>
                        <details v-else>
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label">{{ contract.extraPayment / 100 }}</div>
                        </details>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.funding')" />
                        <div v-if="!anonMode" class="label">{{ detailContract.assistancePayment / 100 }}</div>
                        <details v-else>
                            <summary class="summary label">{{ $t('pages.employeeContract.showDetails') }}</summary>
                            <div class="label">{{ contract.assistancePayment / 100 }}</div>
                        </details>
                    </div>
                </div>

                <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.overTimeBonus')"
                        :styleText="titleStyle" style="width: 100%" />
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.bonusHour')" />
                        <div class="label">{{ detailContract.overtimeBonusHour / 100 }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.bonusShift')" />
                        <div class="label">{{ detailContract.overtimeBonusShift / 100 }}</div>
                    </div>
                    <div class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.holidayBonus')" />
                        <div class="label">{{ $helpers.formatHolidayArray(detailContract.holidayTypes) }}</div>
                    </div>
                </div>

                <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.nightWork')"
                        :styleText="titleStyle" style="width: 100%" />
                <div class="md-card-select">
                    <div v-if="detailContract.calculateNightWork" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.nightWorkFrom')" />
                        <div class="label">{{ detailContract.nightWorkFrom }}</div>
                    </div>
                    <div v-if="detailContract.calculateNightWork" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.nightWorkTo')" />
                        <div class="label">{{ detailContract.nightWorkTo }}</div>
                    </div>
                    <div v-if="detailContract.calculateNightWork && (detailContract.nightWorkMode == 1 ||
                     detailContract.nightWorkMode == 3 || detailContract.nightWorkMode == 5 )" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.bonusHour')" />
                        <div class="label">{{ detailContract.nightWorkBonusHour / 100 }}</div>
                    </div>
                    <div v-if="detailContract.calculateNightWork && (detailContract.nightWorkMode == 1 ||
                     detailContract.nightWorkMode == 2 || detailContract.nightWorkMode == 4 )" class="cd-input">
                        <labelc type="header" class="label" :text=" $t('pages.employeeContract.bonusShift')" />
                        <div class="label">{{ detailContract.nightWorkBonusShift / 100 }}</div>
                    </div>
                </div>

                <div v-if="detailContract.comment || detailContract.exitReason">
                    <labelc type="header" class="wide-label" :text="$t('global.general.additionalInfo')"
                            :styleText="titleStyle" style="width: 100%" />
                    <div class="md-card-select">
                        <div v-if="detailContract.comment" class="cd-input">
                            <labelc type="header" class="label" :text=" $t('global.general.comment')" />
                                <div class="label">{{ detailContract.comment }}</div>
                        </div>
                        <div v-if="detailContract.exitReason" class="cd-input">
                            <labelc type="header" class="label" :text=" $t('pages.employeeContract.exitReason')" />
                                <div class="label">{{ exitReasonMap[detailContract.exitReason] ?
                                    exitReasonMap[detailContract.exitReason] : detailContract.exitReason}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="md-card dialog" v-if="modalEndcontract">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('pages.employeeContract.finishContract') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalEndcontract = false"></i>
            </h6>
            <div v-if="!loading" class="md-card-body">
                <div class="md-card-select">
                    <p><b style="color: red">{{ $t('pages.employeeContract.messages.endContractWarning') }}</b></p>
                </div>

                <labelc type="header" class="wide-label" :text="$t('pages.employeeContract.selectContractEndDate')"
                        :styleText="titleStyle" style="width: 100%" />
                <div class="md-card-select">
                    <div class="cd-input">
                        <labelc type="header" class="label" :text="$t('pages.employeeContract.contractEndsAt')" />
                        <div @click="popupTo = false" class="cd-input">
                            <input @focus="toggleInputPopup('to', false)" type="date"
                                   v-model="endDate" />
                        </div>
                        <div v-if="popupTo" class="error-label">{{
                                $t('pages.employeeContract.errors.contractToMissing')
                            }}
                        </div>
                    </div>
                    <div class="cd-input" v-if="contractToEdit">
                        <labelc type="header" class="label" :text="$t('global.general.comment')" />
                        <div class="cd-input">
                            <input id="endwizard-comment" type="text" v-model="endingContractComment" />
                        </div>
                    </div>
                    <div class="cd-input" v-if="contractToEdit">
                        <labelc type="header" class="label" :text="$t('pages.employeeContract.exitReason')" />
                        <div class="dropdown">
                            <dropdownsearch id="endwizard-exitReason" class="filters" :state="filtersExitReason" />
                        </div>
                    </div>
                </div>
                <div class="right">
                    <buttonc type="rectangle red" :label="$t('pages.employeeContract.finishContract')"
                             @click="endContract()" style="width: auto; float: right" />
                    <buttonc type="rectangle" :label="$t('global.ui.cancel')" @click="modalEndcontract = false"
                             style="width: auto; float: right" />
                </div>
            </div>
            <div v-show="loading">
                <div style="height: 200px;">
                    <div class="loading">
                        <i class="fas fa-spinner"></i>
                    </div>
                </div>
            </div>
        </div>


        <div class="md-card dialog" v-if="modalEditorend">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('pages.employeeContract.contractChange') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalEditorend = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select" v-if="contractToEdit && contractToEdit.approved && editingCurrentContract">
                    {{ $t('pages.employeeContract.messages.approvedContractNotEditable') }}:<br /><br /><span
                    style="font-family: DistrictProBold,serif;">&bull; {{ $t('pages.employeeContract.messages.createContractChange')
                    }}: </span>{{ $t('pages.employeeContract.messages.createContractChangeInfo') }}<br /><br /><span
                    style="font-family: DistrictProBold,serif;">&bull; {{ $t('pages.employeeContract.finishContract')
                    }}: </span>{{ $t('pages.employeeContract.messages.endContractInfo') }}<br />
                </div>
                <div class="md-card-select" v-else-if="contractToEdit && contractToEdit.approved">
                    {{ $t('pages.employeeContract.messages.approvedContractNotEditable') }}
                </div>
                <div v-else class="md-card-select">
                    {{ $t('pages.employeeContract.messages.editOrEndContractQuestion') }}
                </div>
                <div class="right">
                    <buttonc  v-if="isLastContract(contractToEdit)" type="rectangle red" :label="$t('pages.employeeContract.finishContract')"
                              @click="modalEditorend = false; updateExitReasonDropdown(true); modalEndcontract = true;"
                              style="width: auto; float: right" />
                    <buttonc v-if="editingCurrentContract || (contractToEdit && !contractToEdit.approved)"
                             type="rectangle green" :label="$t(contractToEdit.approved ?
                         'pages.employeeContract.messages.createContractChange' : 'pages.employeeContract.contractChange')"
                             @click="modalEditorend = false; editContract();"
                             style="width: auto; float: right" />
                    <buttonc type="rectangle" :label="$t('global.ui.cancel')" @click="modalEditorend = false"
                             style="width: auto; float: right" />
                </div>
            </div>
        </div>


        <div class="md-card dialog" v-if="modalUploaderror">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('pages.employeeContract.messages.uploadNotPossible') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalUploaderror = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <span>{{ $t('pages.employeeContract.messages.uploadNotPossibleInfo') }}</span>
                </div>
                <div class="right">
                    <buttonc type="rectangle green" :label="$t('global.ui.understand')" @click="modalUploaderror = false"
                             style="width: auto; float: right" />

                </div>
            </div>
        </div>

        <input class="inputFile" type="file" id="contractfile" @change="fileSelected" style="display:none;"
               accept="image/jpeg, image/png, application/pdf" ref="fileInput" />
    </div>
</template>

<script>
import dropdownsearch from '../../uicomponents/dropdownsearch.vue'
import { mapState, mapGetters } from 'vuex';
import slider from '../../uicomponents/slider.vue'
export default {
    components: {
        dropdownsearch,
        slider
    },
    name: 'employeecontract',
    data() {
        return {

            loading: false,
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            modalCreatecontract: false,
            modalContractdetails: false,
            modalEditorend: false,
            modalUploaderror: false,
            modalEndcontract: false,
            scrolling: false,
            scrollTop: 150,
            collapseInput: false,
            collapseGrid: false,
            dropdowns: [],
            wizardPage: 1,
            hasErrors: 0,
            newContract: {},
            popupdisabled: true,
            probationEnabled: false,
            deadlineEnabled: false,
            ccEnabled: false,
            noContractTo: false,
            itemsContractTemplate: [],
            filtersContractTemplate: {},
            contractTemplateMap: {},
            itemsEmploymentType: [],
            filtersEmploymentType: {},
            employmentTypeMap: {},
            itemsEmployeeCategory: [],
            filtersEmployeeCategory: {},
            employeeCategoryMap: {},
            itemsContractType: [],
            filtersContractType: {},
            contractTypeMap: {},
            itemsPartTimeType: [],
            partTimeTypeMap: {},
            filtersPartTimeType: {},
            itemsPaymentType: [],
            filtersPaymentType: {},
            paymentTypeMap: {},
            itemsWageType: [],
            itemsNightWorkMode: [],
            filtersNightWorkMode: {},
            itemsHolidayType: [],
            filtersHolidayType: {},
            filtersExitReason: {},
            filtersWageType: {},
            wageTypeMap: {},
            nightWorkModeMap: {},
            exitReasonMap: {},
            itemsCollectiveContract: [],
            filtersCollectiveContract: {},
            itemsEmployeeType: [],
            filtersEmployeeType: {},
            itemsEmploymentModel: [],
            filtersEmploymentModel: {},
            filtersMlWageGroup: {},
            nightWorkerTypeMap: {},
            popupContracttemplateName: false,
            popupContracttemplateNameDuplicate: false,
            popupJobName: false,
            popupEmploymentType: false,
            popupEmployeeCategory: false,
            popupContractType: false,
            popupWorkDays: false,
            popupFrom: false,
            popupTo: false,
            popupProbationTo: false,
            popupDeadlineTo: false,
            popupCollectiveContract: false,
            popupEmployeeType: false,
            popupVacationTime: false,
            popupPaymentType: false,
            popupWageType: false,
            popupPayment: false,
            popupNightWorkMode: false,
            popupNightWorkFrom: false,
            popupNightWorkTo: false,
            popupExtraPayment: false,
            popupMlWageGroup: false,
            contractFile: null,
            uploadFile: null,
            detailContract: null,
            uploadContract: null,
            contractToEdit: null,
            endDate: null,
            endingContractComment: null,
            endingContractExitReason: null,
            editing: false,
            contractTemplates: [],
            toggleEntries: [
                {label:this.$t('store.openingHours.weekDay1Short'), value: 1, selected: true},
                {label:this.$t('store.openingHours.weekDay2Short'), value: 2, selected: true},
                {label:this.$t('store.openingHours.weekDay3Short'), value: 3, selected: true},
                {label:this.$t('store.openingHours.weekDay4Short'), value: 4, selected: true},
                {label:this.$t('store.openingHours.weekDay5Short'), value: 5, selected: true},
                {label:this.$t('store.openingHours.weekDay6Short'), value: 6, selected: true},
                {label:this.$t('store.openingHours.weekDay7Short'), value: 7, selected: true},
            ],
            itemsAccPeriodPriority: [{label: this.$t('pages.employeeContract.automatic'), value: null},
                {label: this.$t('global.ui.prio') + " 1", value: 1},
                {label: this.$t('global.ui.prio') + " 2", value: 2},
                {label: this.$t('global.ui.prio') + " 3", value: 3},
            ],
            filtersAccPeriodPriority: {},
            toggleAll: false,
            titleStyle: {margin: '0', padding: '6px', fontSize: '16px'},
            headerLabelStyle: "background: var(--md); color: white; width: 100%; border-bottom: 1px solid var(--md); margin: 0 8px 16px 0;"
        }
    },
    watch: {
        nameFilter: function (val, oldVal) {
            if (val === '') {
                this.dataFiltered = this.gridData.data.slice();
                return;
            }
            this.dataFiltered = this.gridData.data.filter(e => (e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
        },
        ccEnabled(newVal, oldVal){
            if(newVal == false){
                this.newContract.collectiveContractId = null;
                this.newContract.collectiveContract = null;
            } else {
                this.updateCollectiveContractDropdown();
            }
            this.updateEmployeeTypeDropdown();
        },
        noContractTo(newVal, oldVal){

            if(newVal == true){
                this.newContract.to = null;
            }
        },
        employee: {
            deep: true,
            handler (val, oldVal){
                this.updateEmploymentModelDropdown();
                this.$forceUpdate();
            }
        },
        contract: {
            deep: true,
            handler (val, oldVal) {
                if (val) {
                    this.loadContractFile(val);
                }
                this.$forceUpdate();
            }
        }
    },
    props: [
        "employee",
        "employeeContracts",
        "contract",
        "pastContracts",
        "futureContracts",
        "contractFiles",
        "employeeTypes",
        "employeeRules",
        "uiData",
        "collectiveContractMap",
        "allowedContractMap",
        "ccMandatory",

    ],
    computed: {
        ...mapGetters(['storeSettings', "mlCollectiveAgreementMap", 'isSuperUser', 'employmentModelMap', 'employeeEmploymentModelMap', 'userInfo', 'permissions', 'anonMode']),
        workEntryDate() {
            let ac =  this.employeeContracts != null ?  this.employeeContracts : [];
            let workEntryDate = this.$helpers.getEmployeeEntryDate(this.employee, ac);
            console.log("workEntryDate", workEntryDate);
            return workEntryDate;
        },
        federalStateMap() {
            let map = {};
            this.uiData.federalStates.forEach(item => map[item.id] = item);
            return map;
        },
        canEditStoreBaseData() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 7);
                if (perm && perm.level > 2) {
                    val = true;
                }
            });

            return val;
        },
        mlWageGroupMap() {
            let map = {};
            Object.values(this.mlCollectiveAgreementMap)
            .forEach(ca => {
                ca.wage_groups.forEach(wg => {
                    map[wg.id] = wg;
                });

            });
            return map;
        },
        contractPopupTotalPayment: function(){
            let payment = 0;
            let extraPayment = 0;
            if(this.newContract.payment == null || this.newContract.payment == '' || isNaN(parseFloat(this.newContract.payment))){
                payment = 0;
            } else {
                let val = this.newContract.payment;
                if(typeof val == 'string'){
                    val = val.replace(',','.');
                }
                payment = parseFloat(val);
            }
            if(this.newContract.extraPayment == null || this.newContract.extraPayment == '' || isNaN(parseFloat(this.newContract.extraPayment))){
                extraPayment = 0;
            } else {
                let val = this.newContract.extraPayment;
                if(typeof val == 'string'){
                    val = val.replace(',','.');
                }
                extraPayment = parseFloat(val);
            }
            return (payment + extraPayment).toFixed(2);
        },
        contractFileUploaded: function() {
            return (this.contractFile && this.contract && this.contract.fileId && this.contractFile.id == this.contract.fileId);
        },
        editingCurrentContract: function(){
            return this.contract && this.contractToEdit && this.contract.id == this.contractToEdit.id
        },
        hasContractChangeDate: function (){
            let currentEntry = this.$parent.employeeContractEntryDate(this.employee,false);
            let currentContractFrom = this.$helpers.extractDateStringTZ(this.contract.from, 'DD.MM.YYYY');
            return currentEntry != currentContractFrom;
        },
        futureContractsState() {
            if (this.futureContracts === undefined || this.futureContracts.length < 1) {
                return null;
            }

            let data = Object.values(this.futureContracts);

            let columns = {
                symbol: " ",
                jobName: this.$t('pages.employeeContract.jobName'),
                weekTimeRegular: this.$t('pages.employeeContract.weekTimeRegular'),
                additionalMonthWorkTime: this.$t('pages.employeeContract.additionalMonthWorkTime'),
                from: this.$t('global.general.contractStart'),
                to: this.$t('global.general.contractEnd'),
                fileId: this.$tc('global.general.document', 1),
                actions: " ",
            };

            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'symbol');
            state.headerMap.symbol.componentStateBuilders = [() => {
                return {
                    componentType: 'buttonc',
                    type: 'button icon-overlay square',
                    icon: 'fas fa-file',
                    styleButton: {marginLeft: 'calc(50%-13px)'},
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'jobName');
            this.$helpers.buildHeaderMapLabel(state.headerMap, 'weekTimeRegular');
            state.headerMap.weekTimeRegular.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedWeekTime(data.weekTimeRegular),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'additionalMonthWorkTime');
            state.headerMap.additionalMonthWorkTime.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedWeekTime(data.additionalMonthWorkTime),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'from');
            state.headerMap.from.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedDate(data.from),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'to');
            state.headerMap.to.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedEndDate(data.to),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'fileId');
            state.headerMap['fileId'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.fileId);
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
            state.headerMap.actions.componentStateBuilders = [
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.details')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-envelope-open',
                        customEvents: {
                            click: () => {
                                this.openDetails(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.edit')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-edit',
                        customEvents: {
                            click: () => {
                                this.openEditModal(data);
                            }
                        }
                    }
                },
                (data) => {
                    return data.fileId ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.openDocument')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-download',
                        customEvents: {
                            click: () => {
                                this.loadAndOpenContractFile(data);
                            }
                        }
                    } : {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.uploadDocument')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-upload',
                        customEvents: {
                            click: () => {
                                this.selectFileForUpload(data);
                            }
                        }
                    }
                },
                (data) => {
                    return data.approved && this.checkApprovalDate(data) ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.approved')
                        },
                        disabled: true,
                        type: 'button icon-overlay square',
                        icon: 'fas fa-file-times',
                    } : {}
                },
                (data) => {
                    return !data.approved && this.isLastContract(data) ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.delete')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-trash',
                        customEvents: {
                            click: () => {
                                this.openDeleteContractModal(data);
                            }
                        }
                    } : {}
                },
            ];

            let entries = Object.entries(state.headerMap);

            entries[0][1].key = 'symbol';
            entries[0][1].width = '5%';
            entries[1][1].key = 'jobName';
            entries[1][1].width = '12%';
            entries[2][1].key = 'weekTimeRegular';
            entries[2][1].width = '12%';
            entries[3][1].key = 'additionalMonthWorkTime';
            entries[3][1].width = '12%';
            entries[4][1].key = 'from';
            entries[4][1].width = '12%';
            entries[5][1].key = 'to';
            entries[5][1].width = '12%';
            entries[6][1].key = 'fileId';
            entries[6][1].width = '12%';
            entries[7][1].key = 'actions';
            entries[7][1].width = '15%';

            state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = { fontSize: '10px' };
            state.alwaysUnfold = false;

            return state;
        },
        pastContractsState() {
            if (this.pastContracts === undefined || this.pastContracts.length < 1) {
                return null;
            }

            let data = Object.values(this.pastContracts);

            let columns = {
                symbol: " ",
                jobName: this.$t('pages.employeeContract.jobName'),
                weekTimeRegular: this.$t('pages.employeeContract.weekTimeRegular'),
                additionalMonthWorkTime: this.$t('pages.employeeContract.additionalMonthWorkTime'),
                from: this.$t('global.general.contractStart'),
                to: this.$t('global.general.contractEnd'),
                fileId: this.$tc('global.general.document', 1),
                actions: " ",
            };

            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'symbol');
            state.headerMap.symbol.componentStateBuilders = [() => {
                return {
                    componentType: 'buttonc',
                    type: 'button icon-overlay square',
                    icon: 'fas fa-file',
                    styleButton: {marginLeft: 'calc(50%-13px)'},
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'jobName');
            this.$helpers.buildHeaderMapLabel(state.headerMap, 'weekTimeRegular');
            state.headerMap.weekTimeRegular.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedWeekTime(data.weekTimeRegular),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'additionalMonthWorkTime');
            state.headerMap.additionalMonthWorkTime.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedWeekTime(data.additionalMonthWorkTime),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'from');
            state.headerMap.from.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedDate(data.from),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'to');
            state.headerMap.to.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.formattedEndDate(data.to),
                    },
                    styleLabel: this.$helpers.styleLabel,
                }
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'fileId');
            state.headerMap['fileId'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.fileId);
            }];

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
            state.headerMap.actions.componentStateBuilders = [
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.details')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-envelope-open',
                        customEvents: {
                            click: () => {
                                this.openDetails(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.edit')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-edit',
                        customEvents: {
                            click: () => {
                                this.openEditModal(data);
                            }
                        }
                    }
                },
                (data) => {
                    return data.fileId ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.openDocument')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-download',
                        customEvents: {
                            click: () => {
                                this.loadAndOpenContractFile(data);
                            }
                        }
                    } : {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.uploadDocument')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-upload',
                        customEvents: {
                            click: () => {
                                this.selectFileForUpload(data);
                            }
                        }
                    }
                },
                (data) => {
                    return !data.approved || !this.checkApprovalDate(data) ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.approve')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-file-check',
                        customEvents: {
                            click: () => {
                                this.openApproveContractModal(data);
                            }
                        }
                    } : {}
                },
                (data) => {
                    return data.approved ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.unapprove')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-file-times',
                        customEvents: {
                            click: () => {
                                this.openUnapproveContractModal(data);
                            }
                        }
                    } : {}
                },
                (data) => {
                    return !data.approved && this.isLastContract(data) ? {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.delete')
                        },
                        type: 'button icon-overlay square',
                        icon: 'fas fa-trash',
                        customEvents: {
                            click: () => {
                                this.openDeleteContractModal(data);
                            }
                        }
                    } : {}
                },
            ];

            let entries = Object.entries(state.headerMap);

            entries[0][1].key = 'symbol';
            entries[0][1].width = '5%';
            entries[1][1].key = 'jobName';
            entries[1][1].width = '12%';
            entries[2][1].key = 'weekTimeRegular';
            entries[2][1].width = '12%';
            entries[3][1].key = 'additionalMonthWorkTime';
            entries[3][1].width = '12%';
            entries[4][1].key = 'from';
            entries[4][1].width = '12%';
            entries[5][1].key = 'to';
            entries[5][1].width = '12%';
            entries[6][1].key = 'fileId';
            entries[6][1].width = '12%';
            entries[7][1].key = 'actions';
            entries[7][1].width = '15%';

            state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = { fontSize: '10px' };
            state.alwaysUnfold = false;

            return state;
        },
        fromDate: {
            get: function() {
                var dateStr;
                if (this.newContract.from != null) {

                    dateStr = this.$helpers.extractDateStringTZ(this.newContract.from);
                }
                return dateStr;
            },
            set: function (val) {

                this.newContract.from = this.$helpers.convertDateTimeStringTZ(val);

                //recalc vacation time
                let workExperienceYears = this.employee.workExperience != null ? this.employee.workExperience/12.0 : 0;
                let vacEntitlement = this.$helpers.calculateContractVacationEntitlement(this.storeSettings, this.workEntryDate, this.$helpers.getMomentFromStringTZ(this.newContract.from), workExperienceYears) * 24 * 60;
                if(this.$helpers.hasAutomaticVacationEntitlement(this.storeSettings) && vacEntitlement > this.newContract.vacationTime){
                    this.newContract.vacationTime = vacEntitlement;
                }


                this.updatePartTimeTypeDropdown(); // update parttime type dropdown to check if partial retirement will work for the new date
                this.updateCollectiveContractDropdown(); // update collective contract dropdown to check if new Date cause a change
            }
        },
        toDate: {
            get: function () {
                var dateStr;
                if (this.newContract.to != null) {
                    if(this.editing){
                        dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.to).format());
                    } else {
                        dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.to).format());
                        //dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.to).add(-1,'days').format());
                    }

                }
                return dateStr;
            },
            set: function (val) {

                this.newContract.to = this.$helpers.convertDateTimeStringTZ(val);
            }
        },
        probationToDate: {
            get: function () {
                var dateStr;
                if (this.newContract.probationTo != null) {
                    if(this.editing){
                        dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.probationTo).format());
                    } else {
                        dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.probationTo).format());
                        //dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.to).add(-1,'days').format());
                    }
                }
                return dateStr;
            },
            set: function (val) {

                this.newContract.probationTo = this.$helpers.convertDateTimeStringTZ(val);
            }
        },
        deadlineToDate: {
            get: function () {
                var dateStr;
                if (this.newContract.deadlineTo != null) {
                    if(this.editing){
                        dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.deadlineTo).format());
                    } else {
                        dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.deadlineTo).format());
                        //dateStr = this.$helpers.extractDateStringTZ(this.$helpers.getMomentFromStringTZ(this.newContract.to).add(-1,'days').format());
                    }
                }
                return dateStr;
            },
            set: function (val) {

                this.newContract.deadlineTo = this.$helpers.convertDateTimeStringTZ(val);
            }
        },
        vacationTimeDays: {
            get: function () {
                var val;
                if (this.newContract.vacationTime != null) {

                    val = Math.max(0, (this.newContract.vacationTime / 60 / 24))


                }  else {
                    return 0;
                }
                return val;
            },
            set: function (val) {

                if(val == null || val == '' || isNaN(parseFloat(val))){
                    this.newContract.vacationTime = 0;
                } else {
                    this.newContract.vacationTime = Math.max(0, Math.round(parseFloat(val)) * 24 * 60);
                }

            }
        },
        weekTimeRegularHours: {
            get: function () {

                var val;
                if (this.newContract.collectiveContractId && this.allowedContractMap[this.newContract.collectiveContractId]) {
                    val = (this.allowedContractMap[this.newContract.collectiveContractId].weekTimeRegular / 60).toFixed(2);

                } else {

                    val = (this.newContract.weekTimeRegular / 60).toFixed(2)

                }
                return val;
            },
            set: function (val) {
                this.newContract.weekTimeRegular = val * 60;
            }
        },
        additionalMonthWorkTimeHours: {
            get: function () {

                var val;
                if (this.newContract.collectiveContractId && this.allowedContractMap[this.newContract.collectiveContractId]) {
                    val = (this.allowedContractMap[this.newContract.collectiveContractId].additionalMonthWorkTime / 60).toFixed(2);

                } else {

                    val = (this.newContract.additionalMonthWorkTime / 60).toFixed(2)

                }
                return val;
            },
            set: function (val) {
                this.newContract.additionalMonthWorkTime = val * 60;
            }
        },
        overtimeCutoff: {
            get: function () {
                let val = (this.newContract.overtimeCutoff  / 60).toFixed(2)

                return val;
            },
            set: function (val) {
                this.newContract.overtimeCutoff  = val * 60;
            }
        },
        weeklyOvertimeCutoff: {
            get: function () {
                let val = (this.newContract.weeklyOvertimeCutoff  / 60).toFixed(2)

                return val;
            },
            set: function (val) {
                this.newContract.weeklyOvertimeCutoff  = val * 60;
            }
        },
        fullTimeCutoff: {
            get: function () {
                var val;
                if (this.newContract.collectiveContractId && this.allowedContractMap[this.newContract.collectiveContractId]) {
                    val = (this.collectiveContractMap[this.allowedContractMap[this.newContract.collectiveContractId].collectiveContractId].fullTimeCutoff / 60).toFixed(2);
                } else {
                    val = (this.newContract.fullTimeCutoff  / 60).toFixed(2)
                }
                return val;
            },
            set: function (val) {
                this.newContract.fullTimeCutoff  = val * 60;
            }
        },
        dayFullTimeCutoff: {
            get: function () {
                var val;
                if (this.newContract.collectiveContractId && this.allowedContractMap[this.newContract.collectiveContractId]) {
                    val = (this.collectiveContractMap[this.allowedContractMap[this.newContract.collectiveContractId].collectiveContractId].dayFullTimeCutoff / 60).toFixed(2);
                } else {
                    val = (this.newContract.dayFullTimeCutoff  / 60).toFixed(2)
                }
                return val;
            },
            set: function (val) {
                this.newContract.dayFullTimeCutoff  = val * 60;
            }
        },
        weekTimeMaxHours: {
            get: function () {
                var val;
                if (this.newContract.collectiveContractId && this.allowedContractMap[this.newContract.collectiveContractId]) {
                    val = (this.collectiveContractMap[this.allowedContractMap[this.newContract.collectiveContractId].collectiveContractId].weekTimeMax / 60).toFixed(2);
                } else {
                    val = 60;
                }
                return val;
            }
        },
        monthTimeRegularHours: {
            get: function(){
                var val;
                if (this.newContract.collectiveContractId && this.allowedContractMap[this.newContract.collectiveContractId]) {
                    val = (this.allowedContractMap[this.newContract.collectiveContractId].monthTimeRegular / 60).toFixed(2);
                } else {
                    val = (this.newContract.weekTimeRegular *4.325 / 60).toFixed(2)
                }
                return val;
            }
        },
        typeWeekTimeRegularHours: {
            get: function () {
                var val;
                if (this.newContract.employeeType.weekTimeRegular != null) {
                    val = (this.newContract.employeeType.weekTimeRegular / 60).toFixed(2);
                }
                return val;
            },
            set: function (val) {
                this.newContract.employeeType.weekTimeRegular = val * 60;
            }
        },
        typeWeekTimeMaxHours: {
            get: function () {
                var val;
                if (this.newContract.employeeType.weekTimeMax != null) {
                    val = (this.newContract.employeeType.weekTimeMax / 60).toFixed(2);
                }
                return val;
            },
            set: function (val) {
                this.newContract.employeeType.weekTimeMax = val * 60;
            }
        },
        typeMonthTimeRegularHours: {
            get: function(){
                var val;
                if(this.newContract.employeeType.monthTimeRegular != null){
                    val = (this.newContract.employeeType.monthTimeRegular / 60).toFixed(2);
                }
                return val;
            },
            set: function(val){
                this.newContract.employeeType.monthTimeRegular = val * 60;
            }
        },
        upcomingContract: {
            get: function () {
                var val;
                for (var i = 0; i < this.futureContracts.length; i++) {
                    var cur = this.futureContracts[i];
                    if (!val) {
                        val = cur;
                    } else {
                        let valDate = new Date(val.from);
                        let curDate = new Date(cur.from);
                        if (curDate < valDate) val = cur;
                    }
                }
                return val;
            }
        }
    },
    created() {
        if (this.contract) {
            this.loadContractFile(this.contract);
        }
        this.updateEmploymentModelDropdown();
        this.loadContractTemplates();
    },
    destroyed() {

    },
    updated() {
        if (this.contract) {
            //this.$helpers.log(this, 'contract updated', this.contract, false);
            if (this.contract.fileId) {
                if (this.contractFile) {
                    if (this.contract.fileId != this.contractFile.id) this.loadContractFile(this.contract);
                } else {
                    this.loadContractFile(this.contract);
                }
            } else {
                if (this.contractFile) this.contractFile = null;
            }
        }
    },
    mounted() {
        this.setupUIDataMaps();
        if(this.ccMandatory){
            this.ccEnabled = true;
        }
        this.$forceUpdate();
    },
    methods: {
        closeCreateContract() {
            this.modalCreatecontract = false;
            this.resetCreateContract();
        },
        resetCreateContract() {
            this.popupContracttemplateName = false;
            this.popupContracttemplateNameDuplicate = false;
            this.popupJobName = false;
            this.popupEmploymentType = false;
            this.popupEmployeeCategory = false;
            this.popupContractType = false;
            this.popupWorkDays = false;
            this.popupFrom = false;
            this.popupTo = false;
            this.popupProbationTo = false;
            this.popupDeadlineTo = false;
            this.popupCollectiveContract = false;
            this.popupEmployeeType = false;
            this.popupVacationTime = false;
            this.popupPaymentType = false;
            this.popupWageType = false;
            this.popupPayment = false;
            this.popupNightWorkMode = false;
            this.popupNightWorkFrom = false;
            this.popupNightWorkTo = false;
            this.popupExtraPayment = false;
            this.popupMlWageGroup = false;
            this.hasErrors = 0;
        },
        toggleAccPeriod(contract){
            if(this.canEditStoreBaseData){
                contract.accPeriodExclusion = !contract.accPeriodExclusion;
                if(contract.accPeriodExclusion){
                    contract.accPeriodPriority = null;
                    this.updateAccPeriodPriorityDropdown();
                }

            }
        },
        ToggleListItem(toggle){
            if(this.canEditStoreBaseData){
                toggle.selected = !toggle.selected;

            }

            this.popupWorkDays = false;
        },
        ToggleAllListItems(){
            if(this.canEditStoreBaseData){
                this.toggleAll = !this.toggleAll
                this.toggleEntries.forEach(t => t.selected = this.toggleAll);

            }

            this.popupWorkDays = false;
        },
        displayBooleanState(val) {
            return {
                componentType: 'buttonc',
                type: 'button icon-overlay square',
                icon: val ? 'fas fa-check' : 'fas fa-times',
                styleButton: {marginRight: 'calc(50% - 13px)'},
            }
        },
        calculateOvertimeCutoffs(contract){
            let dailyOverTimeCutoff = contract.overtimeCutoff;

            let weeklyOvertimeCutoff = contract.weeklyOvertimeCutoff

            return {overtimeCutoff: dailyOverTimeCutoff, weeklyOvertimeCutoff: weeklyOvertimeCutoff}
        },
        updateEmploymentModelDropdown() {
            let view = this;
            this.itemsEmploymentModel = [];
            let selectedItem = null;
            Object.values(this.employmentModelMap).forEach(model => {
                let cur = {
                    label: model.name,
                    name: model.name,
                    obj: model,
                    value: model.id
                };
                if(this.employeeEmploymentModelMap[''+this.employee.remoteId] && this.employeeEmploymentModelMap[''+this.employee.remoteId].employmentModelId == model.id) {
                    selectedItem = cur;
                }
                this.itemsEmploymentModel.push(cur);
            })

            this.itemsEmploymentModel.sort((a, b) => {
                return a.label.localeCompare(b.label);
            })
            this.filtersEmploymentModel = {
                toggled: false,
                displayedItems: this.itemsEmploymentModel,
                input: selectedItem != null ? selectedItem.label :this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsEmploymentModel),
                onceSelected: function ($event, item, searchbar) {
                    view.updateEmploymentModel(item.obj);


                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateEmploymentModel(employmentModel){
            let view = this;
            // update employee type
            let url = '/api/sec/employmentmodel/employee';
            let params = {
                storeId: this.$store.state.storeId,
                companyId: this.storeSettings.companyId
            }


            let payload = {
                'remoteId': this.employee.remoteId,
                'employmentModelId': employmentModel.id,
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload,
                params: params,
            }).then(response => {
                view.$store.commit('setEmployeeEmploymentModelMapEntry', {
                    id: ''+view.employee.remoteId,
                    employmentModelId: employmentModel.id
                });

                view.$helpers.success (view.$t('global.notifications.saved'),view.$t('global.notifications.employmentModelUpdated'));
                view.updateEmploymentModelDropdown();
            }).catch(function (error) {
                view.updateEmploymentModelDropdown();
                view.$helpers.error (view.$t('global.notifications.error'),view.$t('global.notifications.employmentModelUpdateFailed'));
                console.log(error)
            });
        },
        isLastContract(contract){
            let res = false;
            if(contract != null){
                if(this.futureContracts.length > 0){
                    if(this.futureContracts[0].id == contract.id){
                        res = true
                    }
                }
                else if(this.contract == null && this.pastContracts.length > 0){
                    if(this.pastContracts[0].id == contract.id){
                        res = true
                    }
                } else if(this.contract != null && this.contract.id == contract.id){

                    res = true;
                }
            }


            return res;
        },
        getCollectiveContractName(id){
            let allowedContract = this.allowedContractMap[id];
            let collectiveContract = this.collectiveContractMap[allowedContract.collectiveContractId];
            let name = collectiveContract.name +" "+(allowedContract.weekTimeRegular/60).toFixed(2)+"h / "+allowedContract.weekWorkDaysRegular+"T";
            if(allowedContract.additionalMonthWorkTime > 0){
                name+=" "+(allowedContract.additionalMonthWorkTime/60).toFixed(2)+" ZS";
            }
            return name;
        },
        setupUIDataMaps() {
            this.uiData.employeeCategories.forEach(item => this.employeeCategoryMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.contractTypes.forEach(item => this.contractTypeMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.employmentTypes.forEach(item => this.employmentTypeMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.paymentTypes.forEach(item => this.paymentTypeMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.wageTypes.forEach(item => this.wageTypeMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.nightWorkerTypes.forEach(item => this.nightWorkerTypeMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.nightWorkModes.forEach(item => this.nightWorkModeMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.exitReasons.forEach(item => this.exitReasonMap[item.id] = this.$helpers.localizedLabel(this, item));
            this.uiData.partTimeTypes.forEach(item => this.partTimeTypeMap[item.id] = this.$helpers.localizedLabel(this, item))
        },
        OnEnter(itemHeader, item) {
            if (itemHeader.OnEnter !== null) {
                itemHeader.OnEnter(item);
            }
        },
        ToggleEdit($event, className) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
            $event.currentTarget.classList.toggle('edit');
            $event.currentTarget.childNodes[1].value = '';
            $event.currentTarget.childNodes[1].focus();
        },
        EndEdit($event) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
        },
        ToggleClassParent($event, className) {
            $event.currentTarget.parentNode.classList.toggle(className);
        },
        ToggleDropDown: function ($event, selection, offsetx, offsety) {
            var event = $event;
            var box = event.currentTarget.getBoundingClientRect();
            var dropdowns = this.dropdowns;
            this.dropdowns.push({
                items: selection,
                el: event.currentTarget,
                remainAfterSelect: true,
                toggled: true,
                offsetx: offsetx,
                offsety: offsety,
                posx: box.left + offsetx,
                posy: box.bottom + offsety,
                onceSelected: function ($eventInner, item, dropdown) {
                    var eventInner = $eventInner;
                    var boxInner = eventInner.currentTarget.getBoundingClientRect();
                    var temp = {
                        items: item.items,
                        offsetx: offsetx + 130,
                        offsety: offsety,
                        posx: box.left + offsetx + 130,
                        toggled: true,
                        posy: boxInner.bottom - 30,
                        pointerDirection: 3,
                        parentCallback: function () {
                            dropdown.toggled = false
                        }
                    };
                    dropdowns.push(temp);
                }
            });
        },
        ToggleContractField(fieldName){
            if(!this.newContract[fieldName]){
                this.newContract[fieldName] = true;
            } else {
                this.newContract[fieldName] = false;
            }
            this.$forceUpdate();
        },
        UpdateNightWorkBonus() {
            
           
            if(this.modalCreatecontract && this.newContract.nightWorkBonusPercentage > 0){
                
                this.SetNightBonusPercentage(this.newContract.nightWorkBonusPercentage);
            }
        },
        SetNightBonusPercentage(val){
            
            let hourlyWage = this.$helpers.CalculateHourlyWageForValues(this.newContract.paymentType, this.newContract.wageType, this.newContract.weekTimeRegular, this.newContract.weekWorkDaysRegular, this.newContract.payment *100.0, this.newContract.extraPayment *100);
            let nightWorkBonusHour = Math.round(hourlyWage * val / 100.0)/100.0;
            this.newContract.nightWorkBonusHour = nightWorkBonusHour;
            this.newContract.nightWorkBonusPercentage = val;
        },
        Init(items, config) {},
        minutesToHours(minutes) {
            return minutes / 60;
        },
        minutesToDays(minutes) {
            return minutes / 60 / 24;
        },
        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
        openEditModal(contract){
            this.contractToEdit = contract;
            
            if(contract.to){
                this.endDate = this.$helpers.getMomentFromStringTZ(contract.to).add(-1, 'days').format('YYYY-MM-DD');
            }
            this.modalEditorend = true;
        },
        openNewContractWizard() {
            this.editing = false;
            this.initNewContract();
            this.wizardPage = 1;
            this.updateDropdowns();
            this.modalCreatecontract = true;
        },
        collectiveContractEmployeeTypeDiffWarning(){
            if(this.ccEnabled && !this.$helpers.isEmpty(this.newContract.collectiveContract) && !this.$helpers.isEmpty(this.newContract.employeeType)){
                var cc = this.newContract.collectiveContract;
                var et = this.newContract.employeeType;
                var ccWeek = cc.weekTimeRegular;
                var etWeek = et.weekTimeRegular;
                var diff = Math.abs(((etWeek/ccWeek) - 1) * 100);
                return diff > 20;
            }
            return false;
        },
        checkContractWizardData() {
            let view = this;
            let c = this.newContract;
            let params = null;
            let ready = true;
            let missing = []

            switch (this.wizardPage) {
                case 1:
                    if (this.$helpers.isEmpty(c.jobName)) missing.push({
                        key: 'jobName'
                    });
                    if (this.$helpers.isEmpty(c.employmentType)) missing.push({
                        key: 'employmentType'
                    });
                    if (this.$helpers.isEmpty(c.employeeCategory)) missing.push({
                        key: 'employeeCategory'
                    });
                    if (this.$helpers.isEmpty(c.contractType)) missing.push({
                        key: 'contractType'
                    });
                    if (this.$helpers.isEmpty(c.from)) missing.push({
                        key: 'from'
                    });
                    if (this.$helpers.isEmpty(c.to) && this.newContract.employmentType == 2) missing.push({
                        key: 'to'
                    });
                    if (this.$helpers.isEmpty(c.probationTo) && this.probationEnabled) missing.push({
                        key: 'probationTo'
                    });
                    if (this.$helpers.isEmpty(c.deadlineTo) && this.deadlineEnabled) missing.push({
                        key: 'deadlineTo'
                    });
                    if (this.ccEnabled && this.$helpers.isEmpty(c.collectiveContract)) missing.push({
                        key: 'collectiveContract'
                    });
                    if (this.$helpers.isEmpty(c.employeeType) && !this.editing && this.storeSettings && !this.storeSettings.simpleMode){
                        missing.push({key: 'employeeType'});
                    }
                    if (this.$helpers.isEmpty(c.vacationTime)) missing.push({
                        key: 'vacationTime'
                    });
                    if (this.$helpers.isEmpty(c.paymentType)) missing.push({
                        key: 'paymentType'
                    });
                    if (this.$helpers.isEmpty(c.wageType)) missing.push({
                        key: 'wageType'
                    });
                    if (this.$helpers.isEmpty(c.payment)) missing.push({
                        key: 'payment'
                    });
                    if (this.$helpers.isEmpty(c.extraPayment)) missing.push({
                        key: 'extraPayment'
                    });
                    
                    if (this.$helpers.isEmpty(c.mlWageGroup)
                        && this.storeSettings.enforceWageGroup
                        && !this.canEditStoreBaseData
                        && this.filtersMlWageGroup.items != null
                        && this.filtersMlWageGroup.items.length > 1){
                            missing.push({ key: 'mlWageGroup' });
                    }
                    break;
                case 2:
                    if (this.$helpers.isEmpty(c.vacationTime)) missing.push({
                        key: 'vacationTime'
                    });
                    if (this.$helpers.isEmpty(c.paymentType)) missing.push({
                        key: 'paymentType'
                    });
                    if (this.$helpers.isEmpty(c.wageType)) missing.push({
                        key: 'wageType'
                    });
                    if (this.$helpers.isEmpty(c.payment)) missing.push({
                        key: 'payment'
                    });
                    if (this.$helpers.isEmpty(c.extraPayment)) missing.push({
                        key: 'extraPayment'
                    });
                    
                    break;
            }
            if(this.newContract.collectiveContractId){
                let cContract = this.collectiveContractMap[this.allowedContractMap[this.newContract.collectiveContractId].collectiveContractId];
                let cContractNightWorkFrom = this.$helpers.getMomentFromStringTZ(cContract.nightWorkFrom, "HH:mm");
                let cContractNightWorkTo = this.$helpers.getMomentFromStringTZ(cContract.nightWorkTo, "HH:mm");

                let tNightWorkFrom = this.$helpers.getMomentFromStringTZ(this.newContract.nightWorkFrom, "HH:mm");
                let tNightWorkTo = this.$helpers.getMomentFromStringTZ(this.newContract.nightWorkTo, "HH:mm");


                if (tNightWorkFrom > cContractNightWorkFrom && this.newContract.calculateNightWork){
                    missing.push({ key: 'nightWorkFrom'});
                } else if (tNightWorkTo < cContractNightWorkTo && this.newContract.calculateNightWork) {
                    missing.push({ key: 'nightWorkTo'});
                }

            }
            if(this.toggleEntries.filter(i => i.selected).length != this.newContract.weekWorkDaysRegular){
                missing.push({ key: 'workDays'});
            }
            if ((c.templateCode === -1 && this.$helpers.isEmpty(c.templateName))
                || (c.templateCode !== 0 && c.templateCode !== -1 && c.templateUpdate && this.$helpers.isEmpty(c.templateName))) {
                missing.push({
                    key: 'contracttemplateName'
                });
            }
            if(c.templateCode === -1 && this.contractTemplates.filter(t => t.title == c.templateName).length > 0){

                missing.push({
                    key: 'contracttemplateNameDuplicate'
                });
            }
            if((c.templateCode !== 0 && c.templateCode !== -1 && c.templateUpdate && this.contractTemplates.filter(t => t.title == c.templateName && t.id != c.templateCode).length > 0)){

                missing.push({
                    key: 'contracttemplateNameDuplicate'
                });
            }



            return missing;
        },
        toggleInputPopup(key, show) {
            this['popup' + String(key).charAt(0).toUpperCase() + String(key).slice(1)] = show;
        },
        wizardPrev() {
            if (this.wizardPage > 1) {
                this.wizardPage = this.wizardPage - 1;
                this.updateDropdowns();
            }
        },
        wizardNext() {
            let missing = this.checkContractWizardData();

            if (missing.length !== 0) {
                this.hasErrors = missing.length;
                missing.forEach((m) => {
                    this.toggleInputPopup(m.key, true);
                });
                return;
            }
            this.hasErrors = 0;

            // data complete for current page
            this.wizardPage = this.wizardPage + 1;
            this.updateDropdowns();


            if (this.wizardPage === 2 && !(this.editing && this.contractToEdit.approved && this.editingCurrentContract)) {
                // Skip page in contract creation
                this.wizardPage = 3;
            }

            if (this.wizardPage !== 3) {
                return;
            }

            this.saveContractTemplate();
            this.newContract.workDays = this.toggleEntries
                .filter(e => e.selected).map(e => e.value);

            if (!this.editing) {
                return this.saveEmployeeContract();
            }
            if (this.contractToEdit.approved && this.editingCurrentContract) {
                this.endCurrentEmployeeContractAndCreateNew(this.newContract.from);
            } else if (!this.contractToEdit.approved) {

                this.updateEmployeeContract();
            }
            // past approved contracts shouldn't be able to be edited => do nothing
        },
        editContract() {
            this.editing = true;
            this.initNewContract(true, this.contractToEdit);
            this.wizardPage = 1;
            this.updateDropdowns();
            this.modalCreatecontract = true;
        },
        endCurrentEmployeeContractAndCreateNew(endDate) {
            this.saveEmployeeContract(this.contract.id);
        },
        endContract() {
            let view = this;
            let url = '/api/sec/employeecontract/exit';
            this.loading = true;

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract/exit');

            let payload = {};

            if(this.contractToEdit.probationTo != null || this.contractToEdit.deadlineTo != null){
                let endDate = this.$helpers.getMomentFromStringTZ(this.endDate).add(1,'days');
                let probationEndDate = this.contractToEdit.probationTo != null ? this.$helpers.getMomentFromStringTZ(this.contractToEdit.probationTo) : null;
                if(probationEndDate != null && endDate < probationEndDate){
                    probationEndDate = endDate;
                    if(this.endingContractComment == null){
                        this.endingContractComment = this.$t('pages.employeeContract.exitProbationBrackets');
                    }
                }

                let deadlineEndDate = this.contractToEdit.deadlineTo != null ? this.$helpers.getMomentFromStringTZ(this.contractToEdit.deadlineTo) : null;
                if(deadlineEndDate != null && endDate < deadlineEndDate){
                    deadlineEndDate = endDate;
                    if(this.endingContractComment == null){
                        this.endingContractComment = this.$t('pages.employeeContract.exitFixedTermBrackets');
                    }
                }

                payload = {
                    id: this.contractToEdit.id,
                    employeeId: this.contractToEdit.employeeId,
                    exitDate: endDate.format(),
                    probationTo: probationEndDate != null ? probationEndDate.format() : null,
                    deadlineTo: deadlineEndDate != null ? deadlineEndDate.format() : null,
                    comment: this.endingContractComment,
                    exitReason: this.endingContractExitReason,

                }
            }else{
                payload = {
                    id: this.contractToEdit.id,
                    employeeId: this.contractToEdit.employeeId,
                    exitDate: this.$helpers.getMomentFromStringTZ(this.endDate).add(1,'days').format(),
                    comment: this.endingContractComment,
                    exitReason: this.endingContractExitReason,

                }
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.contractToEdit.to = view.endDate;
                view.endDate = null;
                view.endingContractComment = null;
                view.endingContractExitReason = null;
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'employeeMapState', 'employeePreferenceMapState', 'employeeContractMapState']});
                view.$emit('contract-updated', view.contractToEdit);

                view.modalEndcontract = false;
                view.$helpers.success (view.$t('global.notifications.success'),view.$t('global.notifications.contractEndedSuccess'));
                if(payload.exitReason != null){

                    view.openTriggerMLEmailForContractExitModal(payload.id, view.exitReasonMap[payload.exitReason], payload.exitDate);
                }

            }).catch(function (error) {
                view.endDate = null;
                view.endingContractComment = null;
                view.endingContractExitReason = null;
                view.modalEndcontract = false;
                if (error.response && error.response.status == 400) {
                    view.$helpers.error (view.$t('global.notifications.error'),view.$t('global.notifications.contractEndedErrorConfirmedMonth'));
                } else {
                    view.$helpers.error (view.$t('global.notifications.error'),view.$t('global.notifications.contractEndedError'));
                }

                console.log(error);
            })
        },
        updateEmployeeContract(){
            let view = this;
            try{
                this.newContract.payment = this.$helpers.euroInputToCents(this.newContract.payment);
                this.newContract.extraPayment = this.$helpers.euroInputToCents(this.newContract.extraPayment);
                this.newContract.assistancePayment = this.$helpers.euroInputToCents(this.newContract.assistancePayment);
                this.newContract.nightWorkBonusHour = this.$helpers.euroInputToCents(this.newContract.nightWorkBonusHour);
                this.newContract.nightWorkBonusShift = this.$helpers.euroInputToCents(this.newContract.nightWorkBonusShift);
                this.newContract.overtimeBonusHour = this.$helpers.euroInputToCents(this.newContract.overtimeBonusHour);
                this.newContract.overtimeBonusShift = this.$helpers.euroInputToCents(this.newContract.overtimeBonusShift);



            }catch(error){
                console.log(error);
            }



                let maxDate = this.$helpers.getMomentTZ().startOf('month').add(1, 'years').startOf('month');
                if(this.contractToEdit.to != null){
                    let d = this.$helpers.getMomentFromStringTZ(this.contractToEdit.to).startOf('month');
                    if(d < maxDate){
                        maxDate = d;
                    }
                    let d2 = this.$helpers.getMomentFromStringTZ(this.contractToEdit.to);
                    if(d2 > d){
                        maxDate.add(1, 'months');
                    }
                }
                let minDate = this.$helpers.getMomentFromStringTZ(this.contractToEdit.from).add(1,'days').startOf('day');

                let dataEntries = [
                    {label:this.$t('pages.employeeContract.editCurrentContract'), key: 'editCurrent', hidden: false, type: 'bool', value: true},
                    {label: this.$t('pages.employeeContract.changeDate'), key: 'from', hidden: true, type: 'date', value: minDate,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let editCurrent = datafill.entries.find(i => i.key == 'editCurrent').value;

                               entryBeforeUpdate.hidden = editCurrent;

                            return entryBeforeUpdate;
                        }
                    }

                ];

                let description =this.$t('pages.employeeContract.editCurrentContractInfo');

                view.closeCreateContract();
                view.editing = false;
                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                            (entries) => {
                                if(entries.hasOwnProperty('from') && entries['from'] < minDate && !entries['editCurrent']){
                                    return {key: 'from', type: 'error', label:this.$t('pages.employeeContract.changeDate'), text:this.$t('pages.employeeContract.errors.changeDateBeforeContractFrom')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries.hasOwnProperty('from') && entries['from'] > maxDate && !entries['editCurrent']){
                                    return {key: 'from', type: 'error', label:this.$t('pages.employeeContract.changeDate'), text:this.$t('pages.employeeContract.errors.changeDateNotAllowedAfter')+maxDate.format("DD.MM.YYYY")}
                                } else {
                                    return null
                                }
                            },

                        ],
                        description: description,
                        selectCallback: function (item) {

                            let nonUpdateableKeys = ['approved', 'id', 'employeeType', 'mlPaymentFound', 'mlPaymentTypeFound', 'mlWageTypeFound', 'validMlWageAmounts'];
                            let keys = Object.keys(view.newContract);
                            let changedKeys = [];
                            keys.forEach(key => {
                                if(!nonUpdateableKeys.includes(key)){
                                    if(key == "to" && view.contractToEdit.to != null && view.newContract.to != null){
                                        let mom_s = view.$helpers.getMomentFromStringTZ(view.contractToEdit.to);
                                        let mom_n = view.$helpers.getMomentFromStringTZ(view.newContract.to).add(1, 'days');
                                        if(mom_s.unix() != mom_n.unix()){
                                            changedKeys.push(key);
                                        }

                                    } else if(key == 'collectiveContract'){

                                        if(view.contractToEdit.collectiveContractId != view.newContract.collectiveContractId){
                                            changedKeys.push('collectiveContractId');
                                        }
                                    } else if(view.newContract[key] != view.contractToEdit[key]){
                                        changedKeys.push(key);
                                    }
                                }
                            });
                            if(view.newContract.to != null){
                                view.newContract.to = view.$helpers.getMomentFromStringTZ(view.newContract.to).add(1, 'days').format();
                            }
                            if(view.newContract.probationTo != null){
                                view.newContract.probationTo = view.$helpers.getMomentFromStringTZ(view.newContract.probationTo).add(1, 'days').format();
                            }
                            if(!view.probationEnabled){
                                view.newContract.probationTo = null;
                                if(!changedKeys.includes("probationTo")){
                                    changedKeys.push("probationTo")
                                }
                            }
                            if(view.newContract.deadlineTo != null){
                                view.newContract.deadlineTo = view.$helpers.getMomentFromStringTZ(view.newContract.deadlineTo).add(1, 'days').format();
                            }
                            if(!view.deadlineEnabled){
                                view.newContract.deadlineTo = null;
                                if(!changedKeys.includes("deadlineTo")){
                                    changedKeys.push("deadlineTo")
                                }
                            }
                            

                            if(item.editCurrent && changedKeys.length > 0){
                               view.$helpers.updateEmployeeContractCall(changedKeys, view.newContract, view.contractToEdit.id, view.employee.id)
                               .then(response => {
                                    view.closeCreateContract();
                                    changedKeys.forEach((key) => {
                                        if(!nonUpdateableKeys.includes(key)){
                                            view.contractToEdit[key] = view.newContract[key];
                                        }
                                    });
                                    if((changedKeys.includes("to") || changedKeys.includes("exitReason")) && view.newContract.to != null && view.newContract.exitReason != null){

                                        view.openTriggerMLEmailForContractExitModal(view.newContract.id, view.exitReasonMap[view.newContract.exitReason], view.newContract.to);
                                    }
                                    view.$emit('contract-updated', view.contractToEdit);
                                    if(!view.$helpers.isEmpty(view.newContract.employeeType) && view.editingCurrentContract){
                                        // update employee type
                                        let url = '/api/sec/employee';
                                        url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/employee');

                                        let payload = {
                                            'id': view.employee.id,
                                            'updateFields': ['typeId'],
                                            'typeId': view.newContract.employeeType.id
                                        }

                                        view.axios({
                                            method: 'put',
                                            headers: {
                                                'AUTHORIZATION': "bearer "+view.$store.state.jwt
                                            },
                                            url: url,
                                            data: payload
                                        }).then(response => {
                                            view.$emit('employeetype-updated', view.employee.id, view.newContract.employeeType);
                                            view.editing = false;
                                            view.$helpers.success (view.$t('global.notifications.contractSaved'), '');
                                        }).catch(function (error) {
                                            view.editing = false;
                                            console.log(error)
                                        });
                                    }else{
                                        view.editing = false;
                                        view.$helpers.success (view.$t('global.notifications.contractSaved'), '');
                                    }
                                }).catch(function (error) {
                                    view.closeCreateContract();
                                    view.editing = false;
                                    view.$helpers.error (view.$t('global.notifications.error'),view.$t('global.notifications.contractSaveError'));
                                    console.log(error)
                                });
                            } else {
                                item.from = view.$helpers.getMomentFromStringTZ(item.from.format("YYYY-MM-DD"), "YYYY-MM-DD");
                                let copy = Object.assign({}, view.newContract);
                                if(view.ccEnabled){
                                    copy.collectiveContractId = view.newContract.collectiveContract.id;
                                } else {
                                    copy.collectiveContractId = null;
                                }

                                if(view.noContractTo){
                                    copy.to = null;
                                }
                                if(copy.collectiveContractId != null){
                                    let cc = view.collectiveContractMap[view.allowedContractMap[copy.collectiveContractId].collectiveContractId];
                                    let contractFrom = item.from;

                                    view.$helpers.checkContractForCollectiveContractChanges(copy, cc, contractFrom);
                                }
                                if(copy.mlWageGroup != null){
                                    let waResult = view.$helpers.findWageAmountForEmploymentGroup(copy, view.mlWageGroupMap, item.from);
                                    if(waResult.validMlWageAmounts.length > 0){


                                        let selectedWageAmount = waResult.selectedWageAmount;
                                        copy.payment = selectedWageAmount.amount;
                                        copy.paymentType = selectedWageAmount.paymentType;
                                        copy.wageType = selectedWageAmount.wageType;

                                        if((copy.paymentType == 1 || copy.wageType == 4) && copy.weekTimeRegular < copy.fullTimeCutoff){
                                            if(copy.collectiveContractId != null && view.storeSettings.workTimeMode == 0){
                                                let fullTime = (copy.fullTimeCutoff * (view.storeSettings.workTimeFactor/Math.pow(10,7)))/60.0;
                                                let hourlyWage = copy.payment / fullTime;
                                                let contractTime = (copy.weekTimeRegular * (view.allowedContractMap[copy.collectiveContractId].workTimeFactor/Math.pow(10,7)))/60.0;

                                                copy.payment = hourlyWage * contractTime;
                                            } else {
                                                let ratio = copy.weekTimeRegular /copy.fullTimeCutoff;
                                                copy.payment = copy.payment * ratio;
                                            }

                                        }
                                    }
                                }
                                let workExperienceYears = view.employee.workExperience != null ? view.employee.workExperience/12.0 : 0;

                                let vacEntitlement = view.$helpers.calculateContractVacationEntitlement(view.storeSettings, view.workEntryDate, item.from, workExperienceYears) * 24 * 60;
                                if(view.$helpers.hasAutomaticVacationEntitlement(view.storeSettings) && vacEntitlement > copy.vacationTime){
                                    copy.vacationTime = vacEntitlement;
                                }

                                copy.holidayTypes = view.newContract.holidayTypes;

                                view.$helpers.copyOnWriteEmployeeContract(copy, view.contractToEdit.id, view.employee.id, item.from)
                                .then(response => {
                                    view.closeCreateContract();
                                    view.$helpers.success (view.$t('global.notifications.contractSaved'), '');
                                    view.$emit('updated', view.employee.id, true);

                                    view.editing = false;
                                }).catch(function (error) {
                                    view.closeCreateContract();
                                    view.editing = false;
                                    view.$helpers.error (view.$t('global.notifications.error'),view.$t('global.notifications.contractSaveError'));
                                    console.log(error)
                                });
                            }

                        },
                    },
                    header:this.$t('pages.employeeContract.changeDate'),
                    remainAfterSelect: false,
                    expanded: true,
                    centered: true,
                    width: '1000px'
                });


        },


        saveEmployeeContract(parentContractId = null) {
            let view = this;
            let url = '/api/sec/employeecontract';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');

            let payload = {
                storeId: this.$store.state.storeId,
                employeeId: this.employee.id,
            }
            if (!this.$helpers.isBlank(this.newContract.jobName)) {
                payload.jobName = this.newContract.jobName;
            }
            if (!this.$helpers.isBlank(this.newContract.employmentGroup)) {
                payload.employmentGroup = this.newContract.employmentGroup;
            }

            payload.from = this.newContract.from;
            if(this.noContractTo){
                this.newContract.to = null;
            }
            payload.calculateNightWork = this.newContract.calculateNightWork? this.newContract.calculateNightWork : false;
            payload.allowPartialShifts = this.newContract.allowPartialShifts? this.newContract.allowPartialShifts : false;
            payload.pregnant = this.newContract.pregnant ? this.newContract.pregnant : false;
            payload.accPeriodExclusion = this.newContract.accPeriodExclusion ? this.newContract.accPeriodExclusion : false;

            payload.to = this.newContract.to? this.$helpers.getMomentFromStringTZ(this.newContract.to).add(1, 'days').format() : null;
            payload.probationTo = this.newContract.probationTo? this.$helpers.getMomentFromStringTZ(this.newContract.probationTo).add(1, 'days').format() : null;
            payload.deadlineTo = this.newContract.deadlineTo ? this.$helpers.getMomentFromStringTZ(this.newContract.deadlineTo).add(1, 'days').format() : null;
            payload.paymentType = this.newContract.paymentType;
            payload.wageType = this.newContract.wageType;
            payload.payment = this.$helpers.euroInputToCents(this.newContract.payment);
            payload.extraPayment = this.$helpers.euroInputToCents(this.newContract.extraPayment);
            payload.assistancePayment = this.$helpers.euroInputToCents(this.newContract.assistancePayment);
            payload.weekWorkDaysRegular = this.newContract.weekWorkDaysRegular;
            payload.workDays = this.newContract.workDays;
            payload.weekTimeRegular = this.newContract.weekTimeRegular;
            payload.additionalMonthWorkTime = this.newContract.additionalMonthWorkTime;
            payload.mlWageGroup = this.newContract.mlWageGroup;

            payload.overtimeCutoff = this.newContract.overtimeCutoff;
            payload.weeklyOvertimeCutoff = this.newContract.weeklyOvertimeCutoff;
            payload.fullTimeCutoff = this.newContract.fullTimeCutoff;
            payload.dayFullTimeCutoff = this.newContract.dayFullTimeCutoff;
            payload.vacationTime = this.newContract.vacationTime;
            payload.employeeCategory = this.newContract.employeeCategory;
            payload.employmentType = this.newContract.employmentType;
            payload.contractType = this.newContract.contractType;
            payload.partTimeType = this.newContract.partTimeType;
            if(this.newContract.contractType == 1){
                payload.partTimeType = null;
            }
            payload.nightWorkerType = this.newContract.nightWorkerType;
            payload.nightWorkFrom = this.newContract.nightWorkFrom;
            payload.nightWorkTo = this.newContract.nightWorkTo;
            payload.nightWorkMode = this.newContract.nightWorkMode;
            payload.nightWorkBonusPercentage = this.newContract.nightWorkBonusPercentage;
            payload.nightWorkCutoff = this.newContract.nightWorkCutoff;
            payload.minNightWorkTime = this.newContract.minNightWorkTime;
            payload.nightWorkBonusHour = this.$helpers.euroInputToCents(this.newContract.nightWorkBonusHour);
            payload.nightWorkBonusShift = this.$helpers.euroInputToCents(this.newContract.nightWorkBonusShift);
            payload.overtimeBonusHour = this.$helpers.euroInputToCents(this.newContract.overtimeBonusHour);
            payload.overtimeBonusShift = this.$helpers.euroInputToCents(this.newContract.overtimeBonusShift);
            if (!this.$helpers.isBlank(this.newContract.comment)) {
                payload.comment = this.newContract.comment;
            }
            if (!this.$helpers.isBlank(this.newContract.exitReason)) {
                payload.exitReason = this.newContract.exitReason;
            }
            if(this.ccEnabled){
                payload.collectiveContractId = this.newContract.collectiveContract.id;
            }
            payload.accPeriodPriority = this.newContract.accPeriodPriority;

            if(this.newContract.vacationEntitlementBase != null && this.newContract.vacationEntitlementBase > 0 && this.newContract.vacationEntitlementBase < 12){
                payload.vacationEntitlementBase = this.newContract.vacationEntitlementBase;
            } else {
                payload.vacationEntitlementBase = null;
            }
            payload.holidayTypes = this.newContract.holidayTypes;

            let specificData = {};
            payload.specificData = specificData;

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(cresponse => {
                view.closeCreateContract();

                if(!view.$helpers.isEmpty(view.newContract.employeeType)){
                    // update employee type and rule
                    let ruleId = null;
                    let rule = view.employeeRules.find(rule => rule.name == "Standard");
                    if(rule != null){
                        ruleId = rule.id;
                    } else if(view.employeeRules.length > 0){
                        ruleId = view.employeeRules[0].id;
                    }
                    let url = '/api/sec/employee';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');

                    let payload = {
                        'id': this.employee.id,
                        'updateFields': ['typeId', 'ruleId'],
                        'typeId': view.newContract.employeeType.id,
                        'ruleId': ruleId
                    }

                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        view.$helpers.success (view.$t('global.notifications.contractSaved'), '');
                        //view.$emit('updated', view.employee.id, true);
                        view.$emit('contract-added', cresponse.data.data);

                        this.editing = false;
                    }).catch(function (error) {
                        view.$helpers.error (view.$t('global.notifications.employeeTypeSaveError'), '');
                        view.$emit('contract-added', cresponse.data.data);
                        console.log(error)
                    });
                } else {
                    view.$emit('contract-added', cresponse.data.data);
                }
            }).catch(function (error) {
                view.closeCreateContract();
                view.editing = false;
                view.$helpers.error (view.$t('global.notifications.error'),view.$t('global.notifications.contractSaveError'));
                console.log(error)
            })
        },
        updateDropdowns() {
            this.updateAccPeriodPriorityDropdown();
            this.updateContractTemplateDropdown();
            this.updateEmploymentTypeDropdown();
            this.updateEmployeeCategoryDropdown();
            this.updateContractTypeDropdown();
            this.updatePartTimeTypeDropdown();
            if(this.ccEnabled){
                this.updateCollectiveContractDropdown();
            }
            this.updateEmployeeTypeDropdown();
            this.updateMlWageGroupDropdown();
            this.updatePaymentTypeDropdown();
            this.updateWageTypeDropdown();
            this.updateHolidayTypesDropdown();
            this.updateNightWorkModeDropdown();
            this.updateExitReasonDropdown();

        },
        updateAccPeriodPriorityDropdown() {
          let view = this;
          this.itemsAccPeriodPriority = [{label: this.$t('pages.employeeContract.automatic'), value: null},
                {label: this.$t('global.ui.prio') + " 1", value: 1},
                {label: this.$t('global.ui.prio') + " 2", value: 2},
                {label: this.$t('global.ui.prio') + " 3", value: 3},
          ];

          let selectedItem = {};
          for(const item of this.itemsAccPeriodPriority) if(item.value == this.newContract.accPeriodPriority) selectedItem = item;

          this.filtersAccPeriodPriority = {
            toggled: false,
            displayedItems: this.itemsAccPeriodPriority,
            input: this.$t('global.ui.pleaseSelect'),
            items: Object.values(this.itemsAccPeriodPriority),
            onceSelected: function ($event, item, searchbar) {
              view.newContract.accPeriodPriority = item.value;
            },
            selectedItem: selectedItem,
            styleLight: true,
            noBorder: false,
          }
        },
        updateContractTemplateDropdown() {
          var view = this;
          this.itemsContractTemplate = [];
          this.itemsContractTemplate.push({
            code: 0,
            label:this.$t('pages.employeeContract.noTemplate'),
            name: "none"
          });
          this.itemsContractTemplate.push({
            code: -1,
            label:this.$t('pages.employeeContract.createNewTemplate'),
            name: "new"
          });

          for (const val of this.contractTemplates) {
            this.itemsContractTemplate.push({
              code: val.id,
              label: val.title,
              name: val.title,
              object: val
            });
          }
          var selectedItem = {};
          for(const item of this.itemsContractTemplate) if(item.code == this.newContract.templateCode) selectedItem = item;

          this.filtersContractTemplate = {
            toggled: false,
            displayedItems: this.itemsContractTemplate,
            input: this.$t('global.ui.pleaseSelect'),
            items: Object.values(this.itemsContractTemplate),
            onceSelected: function ($event, item, searchbar) {
              view.newContract.templateCode = item.code;
              if (item.code !== -1 && item.code !== 0) {
                view.setTemplateData(item.object);
                view.updateDropdowns();
              }
            },
            selectedItem: selectedItem,
            styleLight: true,
            noBorder: false,
          }
        },
        setTemplateData(item) {
            let view = this;

            view.newContract.templateName = item.title != null ? item.title : "";
            view.newContract.templateUpdate = false;
            view.newContract.jobName = item.jobName != null ? item.jobName : this.$tc('global.general.employee');
            view.newContract.employmentGroup = item.employmentGroup != null ? item.employmentGroup : "";
            view.newContract.employmentType = item.employmentType != null ? item.employmentType : 1;
            view.newContract.employeeCategory = item.employeeCategory != null ? item.employeeCategory : 2;
            view.newContract.contractType = item.contractType != null ? item.contractType : 1;
            view.newContract.partTimeType = item.partTimeType != null ? item.partTimeType : null;
            view.newContract.pregnant = item.pregnant != null ? item.pregnant : false;
            view.newContract.accPeriodExclusion = item.accPeriodExclusion != null ? item.accPeriodExclusion : false;
            view.newContract.allowPartialShifts = item.allowPartialShifts != null ? item.allowPartialShifts : false;

            if (item.collectiveContractId != null) {
                view.newContract.collectiveContractId = item.collectiveContractId;
            } else {
                item.collectiveContract = undefined;
            }
            if (item.employeeTypeId != null) {
                view.newContract.employeeType = {};
                view.newContract.employeeType.id = item.employeeTypeId;
            } else {
                view.newContract.employeeType = undefined;
            }
            view.newContract.vacationTime = item.vacationTime != null ? item.vacationTime : 36000;
            view.newContract.paymentType = item.paymentType != null ? item.paymentType : 2;
            view.newContract.wageType = item.wageType != null ? item.wageType : 4;
            view.newContract.payment = item.payment != null ? item.payment/100 : 0;
            view.newContract.extraPayment = item.extraPayment != null ? item.extraPayment/100 : 0;
            view.newContract.assistancePayment = item.assistancePayment != null ? item.assistancePayment/100 : 0;
            view.newContract.overtimeBonusHour = item.overtimeBonusHour != null ? item.overtimeBonusHour/100 : 0;
            view.newContract.overtimeBonusShift = item.overtimeBonusShift != null ? item.overtimeBonusShift/100 : 0;
            view.newContract.calculateNightWork = view.storeSettings.nightWorkRequired ? true : (item.calculateNightWork != null ? item.calculateNightWork : false);
            view.newContract.nightWorkerType = item.nightWorkerType != null ? item.nightWorkerType : 1;
            view.newContract.nightWorkFrom = item.nightWorkFrom != null ? item.nightWorkFrom : '22:00';
            view.newContract.nightWorkTo = item.nightWorkTo != null ? item.nightWorkTo : '06:00';
            view.newContract.nightWorkMode = item.nightWorkMode != null ? item.nightWorkMode : 1;
            
            view.newContract.nightWorkCutoff = item.nightWorkCutoff != null ? item.nightWorkCutoff : 50;
            view.newContract.minNightWorkTime = item.minNightWorkTime != null ? item.minNightWorkTime : 0;
            view.newContract.nightWorkBonusHour = item.nightWorkBonusHour != null ? item.nightWorkBonusHour/100 : 0;
            view.newContract.nightWorkBonusShift = item.nightWorkBonusShift != null ? item.nightWorkBonusShift/100 : 0;
            view.newContract.comment = item.comment != null ? item.comment : "";
            view.newContract.exitReason = item.exitReason;

            view.ccEnabled = item.ccEnabled != null ? item.ccEnabled : this.newContract.collectiveContractId != null || this.ccMandatory;
            view.probationEnabled = item.probationEnabled != null ? item.probationEnabled : false;
            view.deadlineEnabled = item.deadlineEnabled != null ? item.deadlineEnabled : false;
            view.newContract.nightWorkBonusPercentage = item.nightWorkBonusPercentage != null ? item.nightWorkBonusPercentage : 0;
            if(view.newContract.nightWorkBonusPercentage > 0){
                
                view.newContract.useNightWorkBonusHourPercentage = true;
                view.SetNightBonusPercentage(view.newContract.nightWorkBonusPercentage);
                view.$forceUpdate();
            }
        },
        updateEmploymentTypeDropdown() {
            var view = this;
            this.itemsEmploymentType = [];
            // dropdown data country
            for (const val of this.uiData.employmentTypes) {
                this.itemsEmploymentType.push({
                    code: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }
            var selectedItem = {};
            for(const item of this.itemsEmploymentType) if(item.code == this.newContract.employmentType) selectedItem = item;

            this.filtersEmploymentType = {
                toggled: false,
                displayedItems: this.itemsEmploymentType,
                input: this.newContract.employmentType != undefined ? this.employmentTypeMap[this.newContract.employmentType] : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsEmploymentType),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.employmentType = item.code;
                    if(item.code == 2){
                        view.noContractTo = false;
                    }
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateEmployeeCategoryDropdown() {
            var view = this;
            this.itemsEmployeeCategory = [];
            // dropdown data country
            for (const val of this.uiData.employeeCategories) {
                this.itemsEmployeeCategory.push({
                    code: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }
            var selectedItem = {};
            for(const item of this.itemsEmployeeCategory) if(item.code == this.newContract.employeeCategory) selectedItem = item;

            this.filtersEmployeeCategory = {
                toggled: false,
                displayedItems: this.itemsEmployeeCategory,
                input: this.newContract.employeeCategory != undefined ? this.employeeCategoryMap[this.newContract.employeeCategory] : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsEmployeeCategory),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.employeeCategory = item.code;
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateContractTypeDropdown() {
            var view = this;
            this.itemsContractType = [];
            // dropdown data country
            for (const val of this.uiData.contractTypes) {
                this.itemsContractType.push({
                    code: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }
            var selectedItem = {};
            for(const item of this.itemsContractType) if(item.code == this.newContract.contractType) selectedItem = item;

            this.filtersContractType = {
                toggled: false,
                displayedItems: this.itemsContractType,
                input: this.newContract.contractType != undefined ? this.contractTypeMap[this.newContract.contractType] : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsContractType),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.contractType = item.code;
                    if(view.newContract.contractType == 1){
                        view.newContract.partTimeType = null;
                        view.newContract = Object.assign({}, view.newContract);
                        view.updatePartTimeTypeDropdown();
                    }
                    view.updateCollectiveContractDropdown();
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updatePartTimeTypeDropdown() {
            var view = this;
            this.itemsPartTimeType = [];
            // dropdown data country
            for (const val of this.uiData.partTimeTypes) {

                // add when either id not 1 (=partial retirement) or partial retirement is possible
                if (val.id !== 1 || view.calculatePartialRetirement(view.employee.dob, view.newContract.from, view.employee.gender)) {
                    this.itemsPartTimeType.push({
                      code: val.id,
                      label: this.$helpers.localizedLabel(this, val),
                      name: this.$helpers.localizedLabel(this, val)
                    });
                }
            }
            var noPartTimeType = {code: null, label:this.$t('pages.employeeContract.noPartTimeType'), name:this.$t('pages.employeeContract.noPartTimeType')};
            this.itemsPartTimeType.push(noPartTimeType);
            var selectedItem = {};
            for(const item of this.itemsPartTimeType){
                if(item.code == this.newContract.partTimeType || item.code == null && this.newContract.partTimeType == null){
                    selectedItem = item;
                }
            }
            // after reselecting a date, partial retirement might not be available anymore. reset selected item and newContract.partTimeType
            if (Object.keys(selectedItem).length === 0) {
                selectedItem = noPartTimeType;
                this.newContract.partTimeType = null;
            }

            this.filtersPartTimeType = {
                toggled: false,
                displayedItems: this.itemsPartTimeType,
                input: this.newContract.partTimeType != undefined ? this.partTimeTypeMap[this.newContract.partTimeType] :this.$t('pages.employeeContract.noPartTimeType'),
                items: Object.values(this.itemsPartTimeType),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.partTimeType = item.code;
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateCollectiveContractDropdown() {

            var view = this;
            this.itemsCollectiveContract = [];
            let selectedItem = null;
            Object.values(this.allowedContractMap).sort((a,b) => {return b.weekTimeRegular - a.weekTimeRegular}).forEach(val => {
                let name = view.getCollectiveContractName(val.id);
                if(val.active || this.newContract.collectiveContractId == val.id){
                    let item = {
                        code: val,
                        label: name,
                        name: name,
                        obj: val
                    }
                    this.itemsCollectiveContract.push(item);
                    if(this.newContract.collectiveContractId == val.id){
                        selectedItem = item;
                    }
                }

            });



            if(!selectedItem && this.itemsCollectiveContract.length > 0){
                selectedItem = this.itemsCollectiveContract[0];

            }
            if(selectedItem){
                let cc = this.collectiveContractMap[selectedItem.obj.collectiveContractId];
                this.newContract.collectiveContract = selectedItem.obj;
                this.newContract.collectiveContractId = selectedItem.obj.id;
                this.newContract.weekTimeRegular = selectedItem.obj.weekTimeRegular;
                this.newContract.additionalMonthWorkTime = selectedItem.obj.additionalMonthWorkTime;

                this.newContract.weekWorkDaysRegular = selectedItem.obj.weekWorkDaysRegular;
                this.newContract.overtimeCutoff = this.collectiveContractMap[selectedItem.obj.collectiveContractId].overtimeCutoff;
                this.newContract.weeklyOvertimeCutoff = this.collectiveContractMap[selectedItem.obj.collectiveContractId].weeklyOvertimeCutoff;

                this.newContract.fullTimeCutoff = this.collectiveContractMap[selectedItem.obj.collectiveContractId].fullTimeCutoff;
                this.newContract.dayFullTimeCutoff = this.collectiveContractMap[selectedItem.obj.collectiveContractId].dayFullTimeCutoff;

                if(this.newContract.weekTimeRegular < this.newContract.fullTimeCutoff && (this.newContract.contractType == 2 || this.newContract.contractType == 3)){

                    this.newContract.overtimeCutoff = cc.partTimeOvertimeCutoff;
                    this.newContract.weeklyOvertimeCutoff = cc.partTimeWeeklyOvertimeCutoff;
                    if(cc.partTimeWeeklyOvertimeAddition != null){
                        this.newContract.weeklyOvertimeCutoff = this.newContract.weekTimeRegular + cc.partTimeWeeklyOvertimeAddition;
                    }

                }
                this.$helpers.checkContractForCollectiveContractChanges(this.newContract, cc, this.$helpers.getMomentFromStringTZ(this.newContract.from))

                this.newContract.nightWorkCutoff = this.collectiveContractMap[selectedItem.obj.collectiveContractId].nightWorkCutoff;
            }
            this.filtersCollectiveContract = {
                toggled: false,
                displayedItems: this.itemsCollectiveContract,
                input: selectedItem ? selectedItem.obj.name :this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsCollectiveContract),
                onceSelected: function ($event, item, searchbar) {

                    let prevCollectiveContract = null;
                    let newCollectiveContract = view.collectiveContractMap[item.obj.collectiveContractId]
                    if (view.newContract.collectiveContractId != null){
                        prevCollectiveContract = view.collectiveContractMap[view.allowedContractMap[view.newContract.collectiveContractId].collectiveContractId];
                    }
                    if(prevCollectiveContract == null || prevCollectiveContract.id != newCollectiveContract.id){

                        view.newContract.nightWorkFrom = view.collectiveContractMap[item.obj.collectiveContractId].nightWorkFrom;
                        view.newContract.nightWorkTo = view.collectiveContractMap[item.obj.collectiveContractId].nightWorkTo;

                        view.newContract.nightWorkCutoff = view.collectiveContractMap[item.obj.collectiveContractId].nightWorkCutoff;
                    }
                    view.newContract.collectiveContract = item.obj;
                    view.newContract.collectiveContractId = item.obj.id;
                    view.newContract.weekTimeRegular = item.obj.weekTimeRegular;
                    view.newContract.additionalMonthWorkTime = item.obj.additionalMonthWorkTime;

                    view.newContract.weekWorkDaysRegular = item.obj.weekWorkDaysRegular;
                    if(view.newContract.weekWorkDaysRegular != view.toggleEntries.filter(i => i.selected).length){
                        let tE = [
                            {label: this.$t('store.openingHours.weekDay1Short'), value: 1, selected: true},
                            {label: this.$t('store.openingHours.weekDay2Short'), value: 2, selected: true},
                            {label: this.$t('store.openingHours.weekDay3Short'), value: 3, selected: true},
                            {label: this.$t('store.openingHours.weekDay4Short'), value: 4, selected: true},
                            {label: this.$t('store.openingHours.weekDay5Short'), value: 5, selected: true},
                            {label: this.$t('store.openingHours.weekDay6Short'), value: 6, selected: true},
                            {label: this.$t('store.openingHours.weekDay7Short'), value: 7, selected: true},
                        ];
                        tE.forEach(i => i.selected = i.value <= view.newContract.weekWorkDaysRegular);
                        view.toggleEntries = tE;
                    }
                    view.newContract.overtimeCutoff = view.collectiveContractMap[item.obj.collectiveContractId].overtimeCutoff;
                    view.newContract.weeklyOvertimeCutoff = view.collectiveContractMap[item.obj.collectiveContractId].weeklyOvertimeCutoff;


                    view.newContract.fullTimeCutoff = view.collectiveContractMap[item.obj.collectiveContractId].fullTimeCutoff;
                    view.newContract.dayFullTimeCutoff = view.collectiveContractMap[item.obj.collectiveContractId].dayFullTimeCutoff;



                    if(item.obj.weekTimeRegular < view.collectiveContractMap[item.obj.collectiveContractId].fullTimeCutoff && view.storeSettings.country == 1){
                        view.newContract.contractType = 2;
                    } else if(item.obj.weekTimeRegular >= view.collectiveContractMap[item.obj.collectiveContractId].fullTimeCutoff){
                        view.newContract.contractType = 1;
                    }

                    if(view.newContract.weekTimeRegular < view.newContract.fullTimeCutoff && (view.newContract.contractType == 2 || view.newContract.contractType == 3)){
                        //use part time cut off
                        view.newContract.overtimeCutoff = newCollectiveContract.partTimeOvertimeCutoff;
                        view.newContract.weeklyOvertimeCutoff = newCollectiveContract.partTimeWeeklyOvertimeCutoff;
                        if(newCollectiveContract.partTimeWeeklyOvertimeAddition != null){
                            view.newContract.weeklyOvertimeCutoff = view.newContract.weekTimeRegular + newCollectiveContract.partTimeWeeklyOvertimeAddition;
                        }
                    }
                    view.$helpers.checkContractForCollectiveContractChanges(view.newContract, newCollectiveContract, view.$helpers.getMomentFromStringTZ(view.newContract.from))
                    //force recompute
                    view.newContract = Object.assign({}, view.newContract);

                    view.updateContractTypeDropdown();
                    view.updateMlWageGroupDropdown();



                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },

        updateMlWageGroupDropdown() {

            let view = this;
            let mlCollectiveAgreementId = null;
            if(this.newContract.collectiveContractId){
                let allowedContract = this.allowedContractMap[this.newContract.collectiveContractId];
                let collectiveContract = allowedContract ? this.collectiveContractMap[allowedContract.collectiveContractId] : null;
                let mlCollectiveAgreement = collectiveContract ? this.mlCollectiveAgreementMap[collectiveContract.mlCollectiveAgreementId] : null;
                mlCollectiveAgreementId = mlCollectiveAgreement ? mlCollectiveAgreement.id : null;
            }
            let itemsMlWageGroup = [];
            let stateId = this.storeSettings.federalState != null ? this.federalStateMap[""+this.storeSettings.federalState].stateId : null;
            Object.values(this.mlWageGroupMap).forEach(val => {
                if(val.contractCollectiveAgreementId == mlCollectiveAgreementId && (stateId == null || val.stateIds.includes(stateId))){
                    itemsMlWageGroup.push({
                        code: val.id,
                        label: val.name,
                        name: val.name
                    });
                }
            });
            itemsMlWageGroup.push({
                code: null,
                label: this.$t('global.ui.none_f'),
                name: this.$t('global.ui.none_f')
            });
            let selectedItem = itemsMlWageGroup.find(i => i.code == this.newContract.mlWageGroup);
            if(!selectedItem){
                this.newContract.mlWageGroup = null;
            }

            let waResult = this.$helpers.findWageAmountForEmploymentGroup(this.newContract, this.mlWageGroupMap);
            view.newContract.validMlWageAmounts = waResult.validMlWageAmounts;
            if(waResult.validMlWageAmounts.length > 0){
                view.newContract.mlPaymentFound = true;

                let selectedWageAmount = waResult.selectedWageAmount;
                view.newContract.payment = selectedWageAmount.amount/100.0;
                view.newContract.paymentType = selectedWageAmount.paymentType;
                view.newContract.wageType = selectedWageAmount.wageType;

                if((view.newContract.paymentType == 1 || view.newContract.wageType == 4) && view.newContract.weekTimeRegular < view.newContract.fullTimeCutoff){
                    if(view.newContract.collectiveContractId != null && view.storeSettings.workTimeMode == 0){
                        let fullTime = (view.newContract.fullTimeCutoff * (view.storeSettings.workTimeFactor/Math.pow(10,7)))/60.0;
                        
                        let hourlyWage = view.newContract.payment / fullTime;
                        let contractTime = (view.newContract.weekTimeRegular * (view.allowedContractMap[view.newContract.collectiveContractId].workTimeFactor/Math.pow(10,7)))/60.0;

                        
                        view.newContract.payment = hourlyWage * contractTime;
                    } else {
                        let ratio = view.newContract.weekTimeRegular /view.newContract.fullTimeCutoff;
                        view.newContract.payment = view.newContract.payment * ratio;
                    }

                }

                if(waResult.validMlWageAmounts.length == 1){
                    view.newContract.mlPaymentTypeFound = true;
                    view.newContract.mlWageTypeFound = true;
                }
                if(view.newContract.nightWorkBonusPercentage > 0){
                    view.SetNightBonusPercentage(view.newContract.nightWorkBonusPercentage);
                }
                view.updatePaymentTypeDropdown();
                view.updateWageTypeDropdown();
            } else {
                view.newContract.mlPaymentFound = false;
                view.newContract.mlPaymentTypeFound = false;
                view.newContract.mlWageTypeFound = false;
                view.updatePaymentTypeDropdown();
                view.updateWageTypeDropdown();
            }



            this.filtersMlWageGroup = {
                toggled: false,
                displayedItems: itemsMlWageGroup,
                input: selectedItem ? selectedItem.name :this.$t('global.ui.pleaseSelect'),
                items: itemsMlWageGroup,
                onceSelected: function ($event, item, searchbar) {


                    view.newContract.mlWageGroup = item.code;
                    view.newContract.employmentGroup = item.name;

                    let waResult = view.$helpers.findWageAmountForEmploymentGroup(view.newContract, view.mlWageGroupMap);
                    view.newContract.validMlWageAmounts = waResult.validMlWageAmounts;

                    if(waResult.validMlWageAmounts.length > 0){
                        view.newContract.mlPaymentFound = true;
                        let selectedWageAmount = waResult.selectedWageAmount;
                        view.newContract.payment = selectedWageAmount.amount/100.0;
                        view.newContract.paymentType = selectedWageAmount.paymentType;
                        view.newContract.wageType = selectedWageAmount.wageType;

                        if((view.newContract.paymentType == 1 || view.newContract.wageType == 4) && view.newContract.weekTimeRegular < view.newContract.fullTimeCutoff){
                            if(view.newContract.collectiveContractId != null && view.storeSettings.workTimeMode == 0){
                                let fullTime = (view.newContract.fullTimeCutoff * (view.storeSettings.workTimeFactor/Math.pow(10,7)))/60.0;

                                let hourlyWage = view.newContract.payment / fullTime;
                                let contractTime = (view.newContract.weekTimeRegular * (view.allowedContractMap[view.newContract.collectiveContractId].workTimeFactor/Math.pow(10,7)))/60.0;
                                
                                view.newContract.payment = hourlyWage * contractTime;
                            } else {
                                let ratio = view.newContract.weekTimeRegular /view.newContract.fullTimeCutoff;
                                view.newContract.payment = view.newContract.payment * ratio;
                            }

                        }

                        if(waResult.validMlWageAmounts.length == 1){
                            view.newContract.mlPaymentTypeFound = true;
                            view.newContract.mlWageTypeFound = true;
                        }
                        if(view.newContract.nightWorkBonusPercentage > 0){
                            view.SetNightBonusPercentage(view.newContract.nightWorkBonusPercentage);
                        }
                        view.updatePaymentTypeDropdown();
                        view.updateWageTypeDropdown();
                    } else {

                        view.newContract.mlPaymentFound = false;
                        view.newContract.mlPaymentTypeFound = false;
                        view.newContract.mlWageTypeFound = false;
                        view.updatePaymentTypeDropdown();
                        view.updateWageTypeDropdown();
                    }


                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }

        },
        updateEmployeeTypeDropdown() {
            var view = this;
            this.itemsEmployeeType = [];
            Object.values(this.employeeTypes).sort((a,b) => {return b.weekTimeRegular - a.weekTimeRegular}).forEach(val => {
                this.itemsEmployeeType.push({
                    code: val,
                    label: val.name,
                    name: val.name,
                    obj: val
                });
            })

            var selectedItem = {};
            for(const item of this.itemsEmployeeType) if(this.newContract.employeeType && item.code.id == this.newContract.employeeType.id) selectedItem = item;

            this.filtersEmployeeType = {
                toggled: false,
                displayedItems: this.itemsEmployeeType,
                input: this.newContract.employeeType != undefined ? this.newContract.employeeType.name : this.ccEnabled? this.$t('global.ui.useStandard') : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsEmployeeType),
                onceSelected: function ($event, item, searchbar) {
                    if(item.code == -1){
                        view.newContract.employeeType = undefined;
                    }else{
                        view.newContract.employeeType = item.obj;
                    }
                    view.newContract = Object.assign({}, view.newContract)
                },
                disabled: true,
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },

        updatePaymentTypeDropdown() {
            var view = this;
            this.itemsPaymentType = [];
            // dropdown data country
            for (const val of this.uiData.paymentTypes) {
                this.itemsPaymentType.push({
                    code: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }
            if(this.newContract.validMlWageAmounts.length > 0){
                let allowedPaymentTypes = this.newContract.validMlWageAmounts.map(i => i.paymentType);

                this.itemsPaymentType = this.itemsPaymentType.filter(i => allowedPaymentTypes.includes(i.code));
                if(this.itemsPaymentType.length == 1){
                    this.newContract.mlPaymentTypeFound = true;
                } else {
                    this.newContract.mlPaymentTypeFound = false;
                }
            }

            let selectedItem = {};
            for(const item of this.itemsPaymentType) if(item.code == this.newContract.paymentType) selectedItem = item;

            let input =  this.newContract.paymentType != undefined ? this.paymentTypeMap[""+this.newContract.paymentType] : this.$t('global.ui.pleaseSelect');

            this.filtersPaymentType = {
                toggled: false,
                displayedItems: selectedItem != null ? [selectedItem] : this.itemsPaymentType,
                input: input,
                items: Object.values(this.itemsPaymentType),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.paymentType = item.code;
                    if(view.newContract.validMlWageAmounts.length > 0){
                        let selectedWa = view.newContract.validMlWageAmounts.filter(i => i.paymentType == item.code);
                        view.newContract.payment = selectedWa[0].amount/100.0;
                        view.newContract.wageType = selectedWa[0].wageType;
                        view.newContract.mlPaymentFound = true;

                    }

                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
                disabledInput: this.newContract.mlPaymentTypeFound
            }
        },
        updateWageTypeDropdown() {
            var view = this;
            this.itemsWageType = [];
            // dropdown data country
            for (const val of this.uiData.wageTypes) {
                this.itemsWageType.push({
                    code: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }
            if(this.newContract.validMlWageAmounts.length > 0){

                let allowedWageTypes = this.newContract.validMlWageAmounts.filter(i => i.paymentType == view.newContract.paymentType).map(i => i.wageType);

                this.itemsWageType = this.itemsWageType.filter(i => allowedWageTypes.includes(i.code));
                if(this.itemsWageType.length == 1){
                    this.newContract.mlWageTypeFound = true;
                } else {
                    this.newContract.mlWageTypeFound = false;
                }
            }
            let selectedItem = {};
            for(const item of this.itemsWageType) if(item.code == this.newContract.wageType) selectedItem = item;

            this.filtersWageType = {
                toggled: false,
                displayedItems: selectedItem != null ? [selectedItem] : this.itemsWageType,
                input: this.newContract.wageType != undefined ? this.wageTypeMap[this.newContract.wageType] : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsWageType),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.wageType = item.code;
                    if(view.newContract.validMlWageAmounts.length > 0){
                        let selectedWa = view.newContract.validMlWageAmounts.filter(i => i.wageType == item.code && i.paymentType == view.newContract.paymentType);
                        view.newContract.payment = selectedWa[0].amount/100.0;
                        view.newContract.mlPaymentFound = true;
                    }
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
                disabledInput: this.newContract.mlWageTypeFound
            }
        },
        updateHolidayTypesDropdown() {
            var view = this;
            this.itemsHolidayTypes = [];
            // dropdown data country
            for (const val of this.uiData.holidayTypes) {
                this.itemsHolidayTypes.push({
                    value: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }
            let selectedItems = [];
            
            for(const item of this.itemsHolidayTypes){
                if(this.newContract.holidayTypes.includes(item.value)){
                    item.selected = true;
                    selectedItems.push(item);
                    

                } 
            } 

            this.filtersHolidayTypes = {
                toggled: false,
                displayedItems: this.itemsHolidayTypes,
                input: this.newContract.holidayTypes.length > 0 ? "" : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsHolidayTypes),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.holidayTypes = searchbar.items.filter(i => i.selected).map(i => i.value);
                    console.log(view.newContract.holidayTypes);
                   
                },
                selectedItem: selectedItems,
                selectMultiple: true,
                styleLight: true,
                noBorder: false,
            }
        },
        updateNightWorkModeDropdown() {
            var view = this;
            this.itemsNightWorkMode = [];
            // dropdown data country
             for (const val of this.uiData.nightWorkModes) {
                this.itemsNightWorkMode.push({
                    code: val.id,
                    label: this.$helpers.localizedLabel(this, val),
                    name: this.$helpers.localizedLabel(this, val)
                });
            }

            var selectedItem = {};
            for(const item of this.itemsNightWorkMode) if(item.code == this.newContract.nightWorkMode) selectedItem = item;

            this.filtersNightWorkMode = {
                toggled: false,
                displayedItems: this.itemsNightWorkMode,
                input: this.newContract.nightWorkMode != undefined ? this.nightWorkModeMap[this.newContract.nightWorkMode] : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsNightWorkMode),
                onceSelected: function ($event, item, searchbar) {
                    view.newContract.nightWorkMode = item.code;
                    if(item.code == 2 || item.code == 4){
                        view.newContract.nightWorkBonusHour = 0;
                        view.newContract.nightWorkBonusPercentage = 0;
                        view.newContract.useNightWorkBonusHourPercentage = false;
                    }
                    if(item.code == 3 || item.code == 5){
                        view.newContract.nightWorkBonusShift = 0;
                    }
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateExitReasonDropdown(ending = false) {
            var view = this;
            let itemsExitReason = [];
            // dropdown data country
             for (const val of this.uiData.exitReasons) {
                itemsExitReason.push({code: val.id, label: this.$helpers.localizedLabel(this, val), name: this.$helpers.localizedLabel(this, val), country: val.country});
            }
            let filteredExitReasons = itemsExitReason.filter(i => i.country == null || i.country == view.storeSettings.country);
            var selectedItem = {};
            let input = null;
            if(ending){
                for(const item of itemsExitReason) if(item.code == this.endingContractExitReason) selectedItem = item;
                input = this.endingContractExitReason != undefined ? this.exitReasonMap[this.endingContractExitReason] : this.$t('global.ui.pleaseSelect');

            } else {
                for(const item of itemsExitReason) if(item.code == this.newContract.exitReason) selectedItem = item;
                input = this.newContract.exitReason != undefined ? this.exitReasonMap[this.newContract.exitReason] : this.$t('global.ui.pleaseSelect');
            }
            this.filtersExitReason = {
                    toggled: false,
                    displayedItems: filteredExitReasons,
                    input: input,
                    items: Object.values(filteredExitReasons),
                    onceSelected: function ($event, item, searchbar) {
                        if(ending){
                            view.endingContractExitReason = item.code;
                        } else {
                            view.newContract.exitReason = item.code;
                        }

                    },
                    selectedItem: selectedItem,
                    styleLight: true,
                    noBorder: false,
            }


        },

        initNewContract(copyExisting = null, editcontract = null) {
            console.log(editcontract)
            this.toggleAll = false;
            if (copyExisting) {
                let contract = editcontract ? editcontract : this.contract;
                contract.templateCode = 0;
                contract.templateUpdate = false;
                this.newContract = Object.assign({},contract);
                if(this.storeSettings.nightWorkRequired){
                    this.newContract.calculateNightWork = true;
                }

                if(contract.approved){
                    if(this.newContract.to != null){
                        this.newContract.from = this.newContract.to;
                    } else {
                        this.newContract.from = this.$helpers.getMomentTZ().startOf('month').format();
                    }
                    this.newContract.probationTo = null;
                    this.newContract.to = null;
                    this.newContract.deadlineTo = null;
                }
                if(this.newContract.to){
                    this.newContract.to = this.$helpers.getMomentFromStringTZ(this.newContract.to).startOf('day').add(-1, 'days').format();
                }
                this.deadlineEnabled = this.newContract.deadlineTo != null;
                if(this.newContract.deadlineTo){
                    this.newContract.deadlineTo = this.$helpers.getMomentFromStringTZ(this.newContract.deadlineTo).startOf('day').add(-1, 'days').format();
                }
                this.newContract.id = undefined;
                this.probationEnabled = this.newContract.probationTo != null;
                if(this.newContract.probationTo){
                    this.newContract.probationTo = this.$helpers.getMomentFromStringTZ(this.newContract.probationTo).startOf('day').add(-1, 'days').format();
                }
                this.newContract.approved = false;
                this.newContract.payment = this.newContract.payment / 100;
                this.newContract.extraPayment = this.newContract.extraPayment / 100;
                this.newContract.assistancePayment = this.newContract.assistancePayment / 100;

                this.newContract.nightWorkBonusHour = this.newContract.nightWorkBonusHour/100;
                this.newContract.nightWorkBonusShift = this.newContract.nightWorkBonusShift/100;
                this.newContract.overtimeBonusHour = this.newContract.overtimeBonusHour/100;
                this.newContract.overtimeBonusShift = this.newContract.overtimeBonusShift/100;
                var empltype = undefined;
                for(const t of this.employeeTypes) if(t.id == this.employee.typeId) empltype = t;
                this.newContract.employeeType = empltype;
                this.ccEnabled = this.newContract.collectiveContractId != null || this.ccMandatory;
                this.noContractTo = !(this.newContract.to != null);
                if(this.ccEnabled){
                    this.updateCollectiveContractDropdown();
                }
                this.newContract.mlPaymentFound = false;
                this.newContract.validMlWageAmounts = [];
                this.newContract.mlPaymentTypeFound = false;
                this.newContract.mlWageTypeFound = false;
                this.newContract.useNightWorkBonusHourPercentage = this.newContract.nightWorkBonusPercentage > 0;
                


                let workExperienceYears = this.employee.workExperience != null ? this.employee.workExperience/12.0 : 0;
                let vacEntitlement = this.$helpers.calculateContractVacationEntitlement(this.storeSettings, this.workEntryDate, this.$helpers.getMomentFromStringTZ(this.newContract.from), workExperienceYears) * 24 * 60;
                
                if(this.$helpers.hasAutomaticVacationEntitlement(this.storeSettings) && vacEntitlement > this.newContract.vacationTime){
                    this.newContract.vacationTime = vacEntitlement;
                }

            } else {
                this.newContract = {
                    templateCode: 0,
                    templateUpdate: false,
                    approved: false,
                    comment: "",
                    contractType: 1,
                    partTimeType: null,
                    employeeCategory: 2,
                    employeeId: this.employee.id,
                    employmentType: 1,
                    from: undefined,
                    to: undefined,
                    jobName: this.$tc('global.general.employee'),
                    employmentGroup: "",
                    nightWorkerType: 1,
                    nightWorkBonusHour: 0,
                    nightWorkBonusShift: 0,
                    overtimeBonusHour: 0,
                    overtimeBonusShift: 0,
                    assistancePayment: 0,
                    payment: 0,
                    extraPayment: 0,
                    paymentType: 2,
                    wageType: this.storeSettings.country == 1 ? 4 : 1,
                    probationTo: null,
                    deadlineTo: null,
                    employeeType: null,
                    vacationTime: this.storeSettings.country == 8 ? 37440: 36000,
                    weekTimeRegular: 40*60,
                    weekWorkDaysRegular: 5,
                    additionalMonthWorkTime: 0,
                    overtimeCutoff: 9*60,
                    weeklyOvertimeCutoff: 40*60,
                    fullTimeCutoff: 40*60,
                    dayFullTimeCutoff: 8*60,
                    collectiveContract: null,
                    nightWorkFrom: '22:00',
                    nightWorkTo: '06:00',
                    nightWorkMode: 3,
                    nightWorkCutoff: 50,
                    minNightWorkTime: 0,
                    calculateNightWork: this.storeSettings.nightWorkRequired,
                    allowPartialShifts: this.storeSettings.allowMultiShiftAssign,
                    pregnant: false,
                    accPeriodExclusion: false,
                    workDays: this.storeSettings.workDays,
                    mlWageGroup: null,
                    validMlWageAmounts: [],
                    mlPaymentTypeFound: false,
                    mlWageTypeFound: false,
                    mlPaymentFound: false,
                    accPeriodPriority: null,
                    vacationEntitlementBase: null,
                    holidayTypes: [1],
                    nightWorkBonusPercentage: 0,
                    useNightWorkBonusHourPercentage: false
                }


                let workExperienceYears = this.employee.workExperience != null ? this.employee.workExperience/12.0 : 0;
                let vacEntitlement = this.$helpers.calculateContractVacationEntitlement(this.storeSettings, this.workEntryDate, this.$helpers.getMomentFromStringTZ(), workExperienceYears);

                this.newContract.vacationTime = vacEntitlement * 24 * 60;
                
                if(this.storeSettings.country == 1 && this.storeSettings.marketType == 1){
                    this.newContract.calculateNightWork = true;
                    this.newContract.nightWorkFrom = '00:00';
                    this.newContract.nightWorkBonusPercentage = 30;
                    this.newContract.useNightWorkBonusHourPercentage = true;

                }
            }
            this.toggleEntries.forEach((entry) => {
                entry.selected = this.newContract.workDays.includes(entry.value);
            });
        },
        inheritedSearchbarStyle(el) {
            $(el).find('.entry').css({
                'width': '100%',
                'position': 'absolute',
                'top': '0px',
                'left': '0px',
                'height': '18px',
                'padding': '0px 1px',
                'color': 'var(--contrast-3)',
            });
            $(el).find('.fa-stack').css({
                'top': '0px',
                'margin-top': '0px',
                'margin-right': '4px',
                'right': '0px'
            });
            $(el).find('input').css({
                'box-shadow': 'none',
                'background': 'none'
            });
            $(el).find('.fa-angle-down').css({
                'color': '#ffffff'
            });
            $(el).find('.fa-circle').css({
                'color': 'var(--contrast-2)'
            });
            $(el).find('.items').css({
                position: 'absolute',
                top: '19px',
                left: '-1px',
                width: 'calc(100% + 2px)',
                'box-shadow': 'none',
            });
            $(el).find('.items .item:even').css({
                background: 'var(--contrast-1)'
            });
            $(el).find('.items .item:odd').css({
                background: 'var(--bg)'
            });
            $(el).find('.items .item').css({
                padding: '4px 0px 4px 4px'
            });
            $(el).find('.item .label').css({
                color: 'var(--contrast-5)',
                'font-size': '10px',
                'margin-top': '0px'
            });
        },
        loadContractTemplates() {
          let url = '/api/sec/employeecontracttemplate';
          url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontracttemplate');

          this.axios({
            method: 'get',
            headers: {
              'AUTHORIZATION': "bearer " + this.$store.state.jwt
            },
            url: url
          }).then((response) => {
            this.contractTemplates =  response.data;
          });
        },
        deleteContractTemplate() {
          let view = this;

          let url = '/api/sec/employeecontracttemplate';
          url = this.$helpers.appendParam("id", view.newContract.templateCode, url, '/api/sec/employeecontracttemplate');
          url = this.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/employeecontracttemplate');

          this.axios({
            method: 'delete',
            headers: {
              'AUTHORIZATION': "bearer " + view.$store.state.jwt
            },
            url: url
          }).then((response) => {
            this.contractTemplates = this.contractTemplates.filter(function(item) {
              return item.id !== view.newContract.templateCode;
            });
            this.newContract.templateCode = 0;
            this.updateContractTemplateDropdown();
          });
        },
        saveContractTemplate() {
          let view = this;
          if (view.newContract.templateCode === -1) {
            view.storeContractTemplate(null);
          } else if (view.newContract.templateCode !== 0 && view.newContract.templateUpdate) {
            view.storeContractTemplate(view.newContract.templateCode);
          } else {
            // do not save template
          }
        },
        storeContractTemplate(id) {
          let view = this;

          let method = 'post';
          let url = '/api/sec/employeecontracttemplate';
          url = this.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/employeecontracttemplate');
          let payload = view.setContractTemplatePayload();

          if (id != null) {
            method = 'put';
            let updateFields = Object.keys(payload);
            payload.id = id;
            payload.updateFields = updateFields;
          }

          this.axios({
            method: method,
            headers: {
              'AUTHORIZATION': "bearer " + view.$store.state.jwt
            },
            url: url,
            data: payload
          }).then((response) => {
            view.$helpers.success (view.$t('pages.employeeContract.templateSaved'), '');
            view.loadContractTemplates();
          });
        },
        setContractTemplatePayload() {
          let view = this;
          return {
            ccEnabled: view.ccEnabled,
            probationEnabled: view.probationEnabled,
            deadlineEnabled: view.deadlineEnabled,
            title: view.newContract.templateName,
            jobName: view.newContract.jobName,
            employmentGroup: view.newContract.employmentGroup,
            employmentType: view.newContract.employmentType,
            employeeCategory: view.newContract.employeeCategory,
            contractType: view.newContract.contractType,
            partTimeType: view.newContract.partTimeType,
            pregnant: view.newContract.pregnant,
            accPeriodExclusion: view.newContract.accPeriodExclusion,
            allowPartialShifts: view.newContract.allowPartialShifts,
            collectiveContractId: view.newContract.collectiveContractId,
            employeeTypeId: view.newContract.employeeType.id,
            vacationTime: view.newContract.vacationTime,
            paymentType: view.newContract.paymentType,
            wageType: view.newContract.wageType,
            payment: Math.round(view.newContract.payment *100),
            extraPayment: Math.round(view.newContract.extraPayment*100),
            assistancePayment: Math.round(view.newContract.assistancePayment*100),
            overtimeBonusHour: Math.round(view.newContract.overtimeBonusHour*100),
            overtimeBonusShift: Math.round(view.newContract.overtimeBonusShift*100),
            calculateNightWork: view.newContract.calculateNightWork,
            nightWorkerType: view.newContract.nightWorkerType,
            nightWorkFrom: view.newContract.nightWorkFrom,
            nightWorkTo: view.newContract.nightWorkTo,
            nightWorkMode: view.newContract.nightWorkMode,
            nightWorkCutoff: view.newContract.nightWorkCutoff,
            minNightWorkTime: view.newContract.minNightWorkTime,
            nightWorkBonusHour: Math.round(view.newContract.nightWorkBonusHour*100),
            nightWorkBonusShift: Math.round(view.newContract.nightWorkBonusShift*100),
            nightWorkBonusPercentage: view.newContract.nightWorkBonusPercentage,
            comment: view.newContract.comment,
            exitReason: view.newContract.exitReason
          };
        },
        loadContractFile(contract) {
            if (contract.fileId) {
                let fileId = contract.fileId;
                let view = this;
                let url = '/api/sec/employeefile';

                url = this.$helpers.appendParam("id", fileId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url
                }).then((response) => {
                    if (this.contract && this.contract.id == contract.id) {
                        this.contractFile = response.data;
                        this.$forceUpdate();
                    } else {
                        var f = response.data;
                        this.contractFiles[f.id] = f;
                    }
                });
            } else {
                this.contractFile = null;
                this.$forceUpdate();
            }
        },
        openContractFile() {
            let url = this.contractFile.url + '/api/file?id=' + this.contractFile.fileId + '&accessToken=' + this.contractFile.accessToken;
            window.open(url, '_blank');
        },
        loadAndOpenContractFile(contract) {
            if (contract.fileId) {
                let fileId = contract.fileId;
                let view = this;
                let url = '/api/sec/employeefile';

                url = this.$helpers.appendParam("id", fileId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url
                }).then((response) => {
                    var f = response.data;
                    if(f.accessToken){
                        let url = f.url + '/api/file?id=' + f.fileId + '&accessToken=' + f.accessToken;
                        window.open(url, '_blank');
                    } else {
                        view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.openDocumentsNotAllowed'));
                    }

                });
            }
        },
        selectFileForUpload(contract) {
            if(contract.approved){
                this.modalUploaderror = true;
            }else{
                this.uploadContract = contract;
                let elem = document.getElementById('contractfile');
                elem.click();
            }
        },
        fileSelected(e) {
            this.uploadFile  = e.target.files[0];

            if (this.uploadFile) {
                this.fileerror = false;
                let view = this;
                let url = '/api/sec/employeefile/upload';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/upload');
                let contractFilename = "AV_"+this.employee.firstName+"_"+this.employee.lastName;
                if(this.uploadContract != null){
                    let date = this.$helpers.getMomentFromStringTZ(this.uploadContract.from);
                    contractFilename += "_"+date.format("DD-MM-YYYY");
                }


                let formData = new FormData();
                formData.append("employeeId", this.employee.id);
                formData.append("name", contractFilename);
                formData.append("documentType", 'CONTRACT');
                formData.append('file', this.uploadFile);

                this.uploading = true;
                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: formData
                }).then(response => {
                    let file = response.data.data;
                    view.updateFileId(view.uploadContract.id, file);
                    view.$emit('file-added', view.uploadContract.id, file);
                    view.uploading = false;
                    view.linkFileToContract(view.uploadContract.id, file.id);
                    view.uploadContract = null;
                }).catch(function (error) {
                    view.fileerror = true;
                    view.uploading = false;
                    console.log(error)
                })
            }
        },
        updateFileId(contractId, file) {
            if (this.contract && this.contract.id == contractId) {
                this.contract.fileId = file.id;
                this.contractFile = file;
            }
        },
        linkFileToContract(contractId, fileId) {
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeecontract';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
            url = this.$helpers.appendParam("employeeId", this.employee.id, url, '/api/sec/employeecontract');

            let payload = {
                id: contractId,
                fileId: fileId,
                updateFields: ["fileId"]
            };
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$forceUpdate();
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            });
        },
        unlinkContractFile() {
            var fileId = this.contract.fileId;
            this.$emit('contract-deleted', fileId);
        },
        checkApprovalDate(contract) {
            if (this.contract && contract.id == this.contract.id) {
                if (this.contract.approvalDate) {
                    let fileDate = new Date(this.contractFile.creationDate);
                    let approvalDate = new Date(this.contract.approvalDate);
                    return fileDate < approvalDate;
                }
            } else {
                if (contract.approvalDate) {
                    var contractFile = this.contractFiles[contract.fileId];
                    if (contractFile) {
                        let fileDate = new Date(contractFile.creationDate);
                        let approvalDate = new Date(contract.approvalDate);
                        return fileDate < approvalDate;
                    }
                }
            }
            return true;
        },
        openApproveContractModal(contract){
            let view = this;
            window.app.popupalerts.push({header: this.$t('pages.employeeContract.messages.approveContractTitle'), number: null, description: this.$t('pages.employeeContract.messages.approveContractMessage'), hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                    var contractId = contract.id;

                    let url = '/api/sec/employeecontract/approve';


                    let params = {
                        storeId: view.$store.state.storeId,
                        id: contractId
                    }
                    let payload = {
                        id: contractId
                    };

                    view.axios({
                        method: 'put',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + view.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        popup.loading = false;
                        popup.hidden = true;
                        contract.approved = true;
                        if (view.contract && view.contract.id == contract.id) {
                            view.contract.approved = true;
                        }
                        view.$helpers.success (view.$t('global.notifications.success'), view.$t('global.notifications.contractApproved'));
                        view.$emit('contract-approved', contractId);
                        view.$forceUpdate();
                    }).catch(function (error) {
                        view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.contractApproveError'));
                        popup.loading = false;
                        popup.hidden = true;
                        view.fileerror = true;
                        console.log(error)
                    });

                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                }
            });
        },
        openUnapproveContractModal(contract){
            let view = this;
            window.app.popupalerts.push({header: this.$t('pages.employeeContract.messages.unapproveContractTitle'), number: null, description: this.$t('pages.employeeContract.messages.unapproveContractMessage'), hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                    var contractId = contract.id;

                    let url = '/api/sec/employeecontract/unapprove';


                    let params = {
                        storeId: view.$store.state.storeId,
                        id: contractId
                    }
                    let payload = {
                        id: contractId
                    };

                    view.axios({
                        method: 'put',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + view.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        popup.loading = false;
                        popup.hidden = true;
                        contract.approved = false;
                        if (view.contract && view.contract.id == contract.id) {
                            view.contract.approved = false;
                        }
                        view.$helpers.success (view.$t('global.notifications.success'), view.$t('global.notifications.contractUnapproved'));
                        view.$emit('contract-approved', contractId);
                        view.$forceUpdate();
                    }).catch(function (error) {
                        view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.contractUnapproveError'));
                        popup.loading = false;
                        popup.hidden = true;
                        view.fileerror = true;
                        console.log(error)
                    });

                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                }
            });
        },
        openTriggerMLEmailForContractExitModal(contractId, exitReason, exitDate){
            let view = this;

            if(!this.employee.dummy){
                this.checkMLExitEmails()
                .then(res => {
                    view.$helpers.OpenPopup({
                        type: 'datafill',
                        componentState: {
                            entries: [],
                            description: view.$t('pages.employeeContract.messages.contractEndInformMlUsersMessage'),
                            positiveButtonLabel: view.$t('global.general.sendEmail'),
                            negativeButtonLabel: view.$t('global.ui.cancel'),
                            selectCallback: function (data) {
                                try {
                                    let url = '/api/sec/employeecontract/exit/ml';
                                    let params = {
                                        storeId: view.$store.state.storeId,
                                        companyId: view.storeSettings.companyId
                                    }
                                    let payload = {
                                        contractId: contractId,
                                        exitReason: exitReason,
                                        exitDate: exitDate,
                                        remoteId: view.employee.remoteId,
                                        accountId: view.userInfo.id,
                                        userName: view.userInfo.firstname+" "+view.userInfo.lastname

                                    };

                                    view.axios({
                                        method: 'post',
                                        params: params,
                                        headers: {
                                            'AUTHORIZATION': "bearer " + view.$store.state.jwt
                                        },
                                        url: url,
                                        data: payload
                                    }).then(response => {
                                        view.$helpers.success (view.$t('global.notifications.success'), view.$t('global.notifications.emailSent'));

                                        view.$forceUpdate();
                                    }).catch(function (error) {
                                        view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.emailSendError'));


                                    });
                                } catch (error) {
                                    view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.emailSendError'));
                                }
                            },
                            deleteCallback: function(data) {

                            }
                        },
                        header: view.$t('pages.employeeContract.messages.contractEndInformMlUsersTitle'),
                        expanded: true,
                        centered: true
                    });

                })

            }

        },
        checkMLExitEmails(){
            let view = this;
            let url = '/api/sec/employeecontract/exit/ml/emails';
            let params = {
                storeId: view.$store.state.storeId,
                companyId: view.storeSettings.companyId
            }
            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + view.$store.state.jwt
                    },
                    url: url,
                }).then(response => {

                    if(response.data && response.data.length > 0){
                        resolve(true)
                    } else {
                        reject(false)
                    }
                }).catch(function (error) {
                    view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.errorCheckMlExitEmails'));
                    reject(false)
                });
            });

        },
        openDetails(c) {
            this.detailContract = c;
            this.modalContractdetails = true;
        },
        contractWithId(contractId) {
            if (this.contract && this.contract.id == contractId) return this.contract;
            var allContracts = this.pastContracts.concat(this.futureContracts);
            for (var i = 0; i < allContracts.length; i++) {
                if (allContracts[i].id == contractId) return allContracts[i];
            }
            return null;
        },
        parentContract(contract) {
            if (contract.parentId) return this.contractWithId(contract.parentId);
        },
        childContract(contract) {
            var parentId = contract.id;
            if (this.contract && this.contract.parentId == parentId) return this.contract;
            var allContracts = this.pastContracts.concat(this.futureContracts);
            for (var i = 0; i < allContracts.length; i++) {
                var cur = allContracts[i];
                if (cur && cur.parentId == parentId) return cur;
            }
            return null;
        },
        openDeleteContractModal(contract){
            let view = this;
            window.app.popupalerts.push({header: this.$t('pages.employeeContract.deleteContract'), number: null, description: this.$t('pages.employeeContract.messages.deleteContractMessage'), hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                    var contractId = contract.id;

                    let url = '/api/sec/employeecontract';


                    let params = {
                        storeId: view.$store.state.storeId,
                        id: contractId
                    }


                    view.axios({
                        method: 'delete',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + view.$store.state.jwt
                        },
                        url: url,
                    }).then(response => {
                        popup.loading = false;
                        popup.hidden = true;

                        view.$helpers.success (view.$t('global.notifications.success'), view.$t('global.notifications.contractDeleted'));
                        view.$emit('contract-deleted', contract);
                        view.$forceUpdate();
                    }).catch(function (error) {
                        view.$helpers.error (view.$t('global.notifications.error'), view.$t('global.notifications.contractDeleteError'));
                        popup.loading = false;
                        popup.hidden = true;

                    });

                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                }
            });
        },
        deleteContract(contract) {
            let view = this;
            let url = '/api/sec/employeecontract';

            url = this.$helpers.appendParam("id", contract.id, url, '/api/sec/employeecontract');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.hideModal('modal-deletecontract');
                view.$emit('contract-deleted', contract);
            }).catch(function (error) {
                console.log(error)
            })

        },
        formattedDate(str) {
            return str ? this.$helpers.getMomentFromStringTZ(str).format("DD.MM.YYYY") : '-';
        },
        formattedEndDate(str) {
            return str ? this.$helpers.getMomentFromStringTZ(str).add(-1, 'days').format("DD.MM.YYYY") : '-';
        },
        formattedWeekTime(mins) {
            return (mins / 60) + " " + this.$tc('global.ui.hours', 2)
        },
        OpenContractDiffReportPopup() {
            let view = this;
            let contracts = [];
            if(this.contract != null){
                contracts.push(this.contract);
            }

            this.pastContracts.forEach(c => {
                contracts.push(c);
            })
            this.futureContracts.forEach(c => {

                contracts.push(c);
            })
            contracts.sort((a, b) => {
                return view.$helpers.getMomentFromStringTZ(a.from).unix() - view.$helpers.getMomentFromStringTZ(b.from).unix();
            })
            let selectableContracts = [];
            for (const [index, c] of contracts.entries()) {

                let from =  view.$helpers.getMomentFromStringTZ(c.from).format("DD.MM.YYYY");
                let to = '';
                if(c.to != null){
                    to = view.$helpers.getMomentFromStringTZ(c.to).add(-1, 'days').format("DD.MM.YYYY");
                }
                if(index != 0){
                    selectableContracts.push({label: from+" - "+to+" "+(c.weekTimeRegular/60.0).toFixed(2)+"h", value: index})
                }
            }


            if(selectableContracts.length > 0){
                selectableContracts.reverse();
                let description = this.$t('pages.employeeContract.messages.contractDiffReportMessage') + "<br/>";

                let dataEntries = [];

                dataEntries.push({label: this.$t('pages.employeeContract.contract'), key: 'contractIndex', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('pages.employeeContract.selectContract'),
                        selectFirst: true,
                        items: selectableContracts,
                    },

                });


                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let newContract = contracts[data.contractIndex];
                            let oldContract = contracts[data.contractIndex -1];
                            view.createContractDiffPdf(oldContract, newContract);
                        }
                    },
                    header: view.$t('pages.employeeContract.messages.contractDiffReportTitle'),
                    expanded: true,
                    centered: true
                });
            }

        },
        createContractDiffPdf(oldContract, newContract){
            let view = this;
            let changedData = [];
            for(let x in oldContract){
                if(!["id", "parentId", "fileId", "employeeId", "specificData", "nightWorkMode", "nightWorkCutoff", "approved", "approvedBy", "approvalDate", 'mlWageGroup', 'accPeriodPriority', 'accPeriodExclusion', 'vacationEntitlementBase'].includes(x)){
                    if(x == 'collectiveContractId' && oldContract[x] != null){
                        let oldCC = view.allowedContractMap[oldContract[x]].collectiveContractId;
                        let newCC = view.allowedContractMap[newContract[x]].collectiveContractId;
                        if(oldCC!= newCC){
                            changedData.push({key: x, oldData: oldContract[x], newData: newContract[x]})
                        }
                    } else if(x == 'workDays'){
                        if(oldContract[x].length != newContract[x].length){
                            changedData.push({key: x, oldData: oldContract[x], newData: newContract[x]})
                        } else {
                            for(let i = 0; i < oldContract[x].length; i++){
                                if(!newContract[x].includes(oldContract[x][i])){
                                    changedData.push({key: x, oldData: oldContract[x], newData: newContract[x]})
                                    break;
                                }
                            }
                        }
                    } else if(oldContract[x] != newContract[x]){
                        
                        if(x == 'payment'){
                            changedData.push({key: x, oldData: oldContract[x], newData: newContract[x]})
                            changedData.push({key: 'extraPayment', oldData: oldContract.extraPayment, newData: newContract.extraPayment})
                        } else if(x == 'extraPayment'){
                            let alreadyExists = changedData.find((item) => item.key == 'extraPayment');
                            if(alreadyExists == null){
                                changedData.push({key: x, oldData: oldContract[x], newData: newContract[x]})
                            }
                        } else {
                            changedData.push({key: x, oldData: oldContract[x], newData: newContract[x]})
                        }
                    }
                }
            }
            let filetitle = this.employee.lastName + ' ' + this.employee.firstName;
            let filename = this.employee.lastName + '_' + this.employee.firstName + '_' + this.$t('pages.employeeContract.contractChange') + '_'+ this.$helpers.getMomentFromStringTZ(newContract.from).format('DD.MM.YYYY') +'.pdf';

            let svdob = this.storeSettings.name+" - "+this.storeSettings.description +" - "+ (this.employee.personnelId ? "PN: "+this.employee.personnelId : "PN: -");


            let subtitle = this.$t('pages.employeeContract.changeSheet') + ': '+this.$helpers.getMomentFromStringTZ(newContract.from).format('DD.MM.YYYY')+" - "
            if(newContract.to != null){
                subtitle+=this.$helpers.getMomentFromStringTZ(newContract.to).add(-1,'days').format('DD.MM.YYYY')
            }


            var imgData = null;
            var repDoc = this.$helpers.reportDoc(filetitle, svdob, subtitle, null, 'p', imgData)
            var doc = repDoc.doc;
            var page = 1;
            var prevPage = page;
            var contentOffsetY = repDoc.contentOffsetY;
            var curY = contentOffsetY;
            var prevDataY = curY;
            var offset = {offsetY: curY, page: page};

            doc.rect(13.9, curY-0.2, 182.2, 297 - curY - 15);
            doc, curY = this.$helpers.reportHeaderColorBlock(doc, this.$t('pages.employeeContract.changedContractData'), curY);

            let data = [];
            data.push({
                key: this.$t('pages.employeeContract.newContractData'),
                value: "",
            });
            changedData.forEach((item) => {
                let label = view.$helpers.contractFieldLabel(item.key);
                let value = "";
                let val = item.newData;
                if(val == null){
                    value = "-";
                } else if(["weekTimeRegular", "overtimeCutoff", "weeklyOvertimeCutoff", "additionalMonthWorkTime", "fullTimeCutoff", "dayFullTimeCutoff"].includes(item.key)){
                    value += (val/60.0).toFixed(2);
                } else if(["weekWorkDaysRegular"].includes(item.key)){
                    value += (val).toFixed(2);
                } else if(["workDays"].includes(item.key)){
                    value += this.$helpers.formatWeekDayArray(val);
                } else if(["payment", "nightWorkBonusHour", "nightWorkBonusShift", "overtimeBonusHour", "overtimeBonusShift", "assistancePayment", "extraPayment"].includes(item.key)){
                    value += (val/100.0).toFixed(2);
                } else if(["from", "to", "probationTo", "deadlineTo"].includes(item.key)){
                    value += view.$helpers.getMomentFromStringTZ(val).format("DD.MM.YYYY HH:mm");
                } else if(item.key == "vacationTime"){
                    value += (val/(24*60.0)).toFixed(2);
                } else if(item.key == "collectiveContractId"){
                    value += view.collectiveContractMap[view.allowedContractMap[val].collectiveContractId].name
                } else if(item.key == "paymentType"){
                    value += view.paymentTypeMap[val]
                } else if(item.key == "wageType"){
                    value += view.wageTypeMap[val]
                } else if(item.key == "contractType"){
                    value += view.contractTypeMap[val]
                }  else if(item.key == "partTimeType"){
                    value += view.partTimeTypeMap[val]
                }  else if(item.key == "employmentType"){
                    value += view.employmentTypeMap[val]
                } else if(item.key == "employeeCategory"){
                    value += view.employeeCategoryMap[val]
                } else if(item.key == "nightWorkerType"){
                    value += view.nightWorkerTypeMap[val]
                } else if(typeof val === "boolean"){
                    value += val? this.$t('global.ui.yes').toUpperCase() : this.$t('global.ui.no').toUpperCase()
                } else if(item.key == "exitReason"){
                    value += view.exitReasonMap[val]
                } else if(item.key == 'holidayTypes'){
                    value+= view.$helpers.formatHolidayArray(val);                    
                } else {
                    value += val;
                }


                data.push({
                    key: label,
                    value: value,
                });
            });

            prevDataY = curY;
            doc, offset = this.$helpers.dataBlock(doc, data, 0, curY, page);
            curY = offset.offsetY;
            page = offset.page;

            data = [];
            data.push({
                key: this.$t('pages.employeeContract.oldContractData'),
                value: "",
            });
            changedData.forEach((item) => {
                let label = view.$helpers.contractFieldLabel(item.key);
                let value = "";
                let val = item.oldData;
                if(val == null){
                    value = "-";
                } else if(["weekTimeRegular", "overtimeCutoff", "weeklyOvertimeCutoff", "additionalMonthWorkTime", "fullTimeCutoff", "dayFullTimeCutoff"].includes(item.key)){
                    value += (val/60.0).toFixed(2);
                } else if(["weekWorkDaysRegular"].includes(item.key)){
                    value += (val).toFixed(2);
                } else if(["workDays"].includes(item.key)){
                    value += this.$helpers.formatWeekDayArray(val);
                } else if(["payment", "extraPayment", "nightWorkBonusHour", "nightWorkBonusShift", "overtimeBonusHour", "overtimeBonusShift", "assistancePayment", "extraPayment"].includes(item.key)){
                    value += (val/100.0).toFixed(2);
                } else if(["from", "to", "probationTo", "deadlineTo"].includes(item.key)){
                    value += view.$helpers.getMomentFromStringTZ(val).format("DD.MM.YYYY HH:mm");
                } else if(item.key == "vacationTime"){
                    value += (val/(24*60.0)).toFixed(2);
                } else if(item.key == "collectiveContractId"){
                    value += view.collectiveContractMap[view.allowedContractMap[val].collectiveContractId].name
                }  else if(item.key == "paymentType"){
                    value += view.paymentTypeMap[val]
                } else if(item.key == "wageType"){
                    value += view.wageTypeMap[val]
                } else if(item.key == "contractType"){
                    value += view.contractTypeMap[val]
                } else if(item.key == "partTimeType"){
                    value += view.partTimeTypeMap[val]
                } else if(item.key == "employmentType"){
                    value += view.employmentTypeMap[val]
                } else if(item.key == "employeeCategory"){
                    value += view.employeeCategoryMap[val]
                } else if(item.key == "nightWorkerType"){
                    value += view.nightWorkerTypeMap[val]
                } else if(typeof val === "boolean"){
                    value += val? this.$t('global.ui.yes').toUpperCase() : this.$t('global.ui.no').toUpperCase()
                } else if(item.key == "exitReason"){
                    value += view.exitReasonMap[val]
                } else if(item.key == 'holidayTypes'){
                    value+= view.$helpers.formatHolidayArray(val);                    
                } else {
                    value += val;
                }

                // only show comment of new contract, not old one
                if(item.key != "comment"){
                data.push({
                    key: label,
                    value: value,
                });
                }

            });

            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '_______________________________________', value: '', keyOnly: true});
            data.push({key: this.$t('pages.employeeContract.employeeSignatureBubble'), value: '', keyOnly: true});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '', value: ''});
            data.push({key: '_______________________________________', value: '', keyOnly: true});
            data.push({key: this.$t('pages.employeeContract.employerSignatureBubble'), value: '', keyOnly: true});

            doc, offset = this.$helpers.dataBlock(doc, data, 95, prevDataY, page);
            prevDataY = offset.offsetY;
            page = offset.page;
            curY = prevDataY > curY? prevDataY : curY;

            this.$helpers.insertPageNumbers(doc);
            //doc.save(filename);

            this.$emit("preview-pdf", {doc: doc, filename: filename, type: this.$t('pages.employeeContext.changeReport')});

        },
        calculatePartialRetirement(dob, contractFrom, gender) {
            let view = this;

            // default from date to first of next month. calculate based on that on new contracts
            let fromMoment = view.$helpers.getMomentTZ().add(1, "M").startOf("month");
            let dobMoment = view.$helpers.getMomentFromStringTZ(dob);
            if (contractFrom != null) {
                fromMoment = view.$helpers.getMomentFromStringTZ(contractFrom);
            }
            let diff = fromMoment.add(1, "days").diff(dobMoment, "years", true);

            // https://www.oesterreich.gv.at/themen/arbeit_und_pension/pension/2/1/Seite.270150.html
            if (gender === "F") {
                // FEMALE
                if (dobMoment < view.$helpers.getMomentFromStringTZ("1964-01-01T00:00Z")) {
                    return diff >= 55.0;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1964-07-01T00:00Z")) {
                    return diff >= 55.5;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1965-01-01T00:00Z")) {
                    return diff >= 56.0;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1965-07-01T00:00Z")) {
                    return diff >= 56.5;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1966-01-01T00:00Z")) {
                    return diff >= 57.0;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1966-07-01T00:00Z")) {
                    return diff >= 57.5;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1967-01-01T00:00Z")) {
                    return diff >= 58.0;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1967-07-01T00:00Z")) {
                    return diff >= 58.5;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1968-01-01T00:00Z")) {
                    return diff >= 59.0;
                }
                else if (dobMoment < view.$helpers.getMomentFromStringTZ("1968-07-01T00:00Z")) {
                    return diff >= 59.5;
                }
                else return diff >= 60.0;
            } else {
                // NON FEMALE // male, divers, etc
                return diff >= 60.0;
            }
        },
    }
}
</script>

<style scoped>
.toggle-list .toggle{
    text-align: center;
    transition: .2s;
    height: 20px;
    width: 35px;
    margin-right: 1px;
    border-right: none;
    border-radius: 0;
    line-height: 20px;
    cursor: pointer;
    position: relative;
    display: inline-block;
    background: var(--contrast-2);
    font-size: 11px;
}

.toggle-list .toggle:first-child{
    border-radius: 5px 0 0 5px;
}
.toggle-list .toggle:last-child{
    border-radius: 0 5px 5px 0;
    margin-right: 0;
}
.toggle-list .toggle:first-child:last-child{
    border-radius: 5px;
    margin-right: 0;
}

.toggle-list .toggle:hover, .toggle-list .toggle-all:hover{
    background: var(--contrast-4);
    color: white;
}

.toggle-list .toggle.selected:hover, .toggle-list .toggle-all.selected:hover{
    background: var(--col-danger);
    color: white;
}

.toggle-list .toggle.selected, .toggle-list .toggle-all.selected{
    background: #6d8d23;
    color: white;
}

.toggle-list .toggle-all{
    height: 20px;
    background: var(--contrast-2);
    font-size: 11px;
}

.page-settings .header {
    margin-top: 16px;
    box-shadow: none!important;
}

.md-card {
    position: fixed;
    z-index: 1000000;
    width: 53%;
    padding-bottom: 10px;
    top: 89px;
    left: 25%;
    right: auto;
    resize: both;
    overflow: hidden
}

.md-card.wide{
    left: max(1vw, calc(50vw - 522px));
    width: 98vw;
    min-width: 720px;
    max-width: 1044px;
    resize: horizontal;
}

.md-card-body {
    max-height: calc(98vh - 139px);
}

.md-card-select {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
    align-items: normal;
    padding-bottom: 16px;
    margin-bottom: 16px;
}

.md-card-select.noborder {
    padding-bottom: 0px;
}

.md-card-select .label {
    width: 140px;
    margin-top: 0;
}

.md-card-select .auto-label {
    width: auto;
}

.cd-input {
    margin: -2px 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
    align-items: center!important;
    padding-bottom: 6px;
}

.cd-input:not(.roinput) > input {
    width: 320px;
}

.slide-container {
    width: 305px;
    padding: 15px;
    margin-left: 18px;
}
.slider {
    width: calc(100% - 40px) !important;
}

.error-label {
    color: var(--col-danger);
    width: 100%;
}

.summary {
    background: var(--md);
    color: #fff;
    padding: 3px;
    border-radius: 5px;
}

</style>
